<template>
  <!-- eslint-disable -->
  <div style="text-align:left;">
    <ModalFiltrosOrdenes ref="modalfiltros" :filtros="filtros" :ordenes="ordenes_calculated" />
    <ModalDescargarExcel ref="modaldescargar" />
    <ModalNuevaAgenda ref="modalnuevaagenda" />
    <ModalCopiarOrden ref="modalcopiarorden" />
    <ModalRecetas ref="modalRecetas" :ordenId="id_orden" @recetas-updated="handleRecetasUpdated" />
    <ModalComentario ref="modalComentario" @comentado="get_ordenes" />

    <div class="column-left">
      <SideNav />
    </div>
 
    <div class="column-right">
      <TopNav />
      <div class="main-container">
        <div v-if="true" class="professionals-container">
          <!-- Page Header -->
          <div class="page-header">
            <div class="header-content">
              <div class="title-section">
                <div class="page-icon" :style="{
                  backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
                }">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14,2 14,8 20,8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10,9 9,9 8,9"></polyline>
                  </svg>
                </div>

                <div>
                  <h1 class="page-title">Atenciones Agendadas</h1>
                  <p class="page-subtitle">
                    Gestión integral de órdenes y atenciones médicas
                  </p>
                </div>
              </div>

              <div class="header-actions" v-if="window.width >= 1200">
                <button @click="pantalla_completa()" :style="{
                  'background-color': prestador.admin.assets.colors.secondary
                }" class="view-toggle-btn">
                  {{
                    (dynamicStyles && dynamicStyles.length > 0)
                      ? "Vista Normal"
                  : "Vista Completa"
                  }}
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Controls Section -->
          <div class="controls-section">
            <div class="controls-container">
              <div class="control-group">
                <button class="control-btn" :style="{
                  'background-color': prestador.admin.assets.colors.primary
                }" @click="$refs.modalfiltros.show()">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polygon points="22,3 2,3 10,12.46 10,19 14,21 14,12.46"></polygon>
                  </svg>
                  Filtrar
                </button>

                <button class="control-btn" :style="{
                  'background-color': prestador.admin.assets.colors.primary
                }" @click="$refs.modaldescargar.show()">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="7,10 12,15 17,10"></polyline>
                    <line x1="12" y1="15" x2="12" y2="3"></line>
                  </svg>
                  Descargar
                </button>

                <button v-if="prestador.id != 16" class="control-btn" :style="{
                  'background-color': prestador.admin.assets.colors.primary
                }" @click="$refs.modalnuevaagenda.show()">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                  Nueva Atención
                </button>

                <div style=" display: inline-block; position: relative; " v-if="window.width >= 1200">
                  <button class="menuCol control-btn" :style="{
                    'background-color': prestador.admin.assets.colors.primary
                  }" @click="menuCol = !menuCol">
                    Ver Columnas
                  </button>
                  <div v-if="menuCol" class="menuCol"
                    style="position:absolute; left:0px; top:47px; background-color:white; width:200px; border: 1px solid rgb(140, 140, 140); border-radius:5px; z-index:100;">
                    <div v-for="(c, key) in cols" :key="key" class="menuCol"
                      style="cursor:pointer; width:100%; text-align:left; padding-left:5px;" @click="setCol(c.var)">
                      {{ c.nombre }}

                      <b-icon v-if="getVal(c.var) == 'true'" class="menuCol" style="color:green;" icon="check" />
                      <b-icon v-else class="menuCol" style="color:red;" icon="x-circle" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="date-controls">
                <div class="date-field">
                  <label>Desde</label>
                  <input id="x1" v-model="dt_dia" type="date" class="date-input" :max="dt_dia2" />
                </div>
                <div class="date-field">
                  <label>Hasta</label>
                  <input id="x2" v-model="dt_dia2" type="date" class="date-input" :min="dt_dia" />
                </div>
              </div>
            </div>
          </div>

          <!-- Hidden link for downloads -->
          <a :href="link" ref="hiddenLink" style="display:none;">Hidden Link</a>

          <!-- Context Menu Popup -->
          <div v-if="popup" class="context-menu" :style="{
            top: mouseY + 'px',
            left: Math.max(10, Math.min(mouseX - 110, window.width - 230)) + 'px',
            transform: (mouseY + 500 > window.height) ? 'translateY(-100%)' : 'none'
          }" @mouseover="popup = true" @mouseleave="popup = false" @touchstart.stop>
            <!-- Menu for Prestador 16 (UC en casa) -->
            <template v-if="prestador.id == 16">
              <div class="context-menu-item" @click="cambiar_profesional_abrir()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                Cambiar profesional o horario
              </div>
              <div class="context-menu-item danger" @click="eliminarOrden()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="3,6 5,6 21,6"></polyline>
                  <path d="M19,6v14a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V6m3,0V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V6"></path>
                </svg>
                Eliminar Atención
              </div>
              <div class="context-menu-item" @click="copyToClipboard()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
                Copiar pacientes
              </div>
              <div class="context-menu-item" @click="toggleConfirmSubMenu($event)">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="22" y1="2" x2="11" y2="13"></line>
                  <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                </svg>
                Enviar confirmación
                <svg v-if="!showConfirmSubMenu" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-left: auto;">
                  <polyline points="6,9 12,15 18,9"></polyline>
                </svg>
                <svg v-else width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-left: auto;">
                  <polyline points="18,15 12,9 6,15"></polyline>
                </svg>
              </div>

              <template v-if="showConfirmSubMenu">
                <div class="context-menu-item sub-item" @click="enviar_confirmacion_email()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                  Confirmación EMAIL/correo
                </div>
                <div class="context-menu-item sub-item" @click="enviar_confirmacion_whatsapp()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="#25D366">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.94 3.659 1.437 5.634 1.437h.005c6.558 0 11.894-5.335 11.897-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                  Confirmación WhatsApp
                </div>
              </template>
              <div class="context-menu-item" @click="copiar_link_pago()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                Enviar Link de Pago
              </div>
              <div class="context-menu-item" @click="copiar_orden()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
                Copiar Atención
              </div>
              <div class="context-menu-item" @click="goto_modificar()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                </svg>
                Modificar Atención
              </div>
              <div class="context-menu-item" @click="goto_receta()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14,2 14,8 20,8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                </svg>
                Detalles de la Atención
              </div>
              <div class="context-menu-item" @click="open()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
                Comentar
              </div>
              <div class="context-menu-item" @click="openRecetasModal">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14,2 14,8 20,8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                </svg>
                Gestionar recetas
              </div>
            </template>

            <!-- Default Menu for other prestadores -->
            <template v-else>
              <div class="context-menu-item" @click="copyToClipboard()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
                Copiar pacientes
              </div>

              <div class="context-menu-item" @click="toggleConfirmSubMenu($event)">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="22" y1="2" x2="11" y2="13"></line>
                  <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                </svg>
                Enviar confirmación
                <svg v-if="!showConfirmSubMenu" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-left: auto;">
                  <polyline points="6,9 12,15 18,9"></polyline>
                </svg>
                <svg v-else width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-left: auto;">
                  <polyline points="18,15 12,9 6,15"></polyline>
                </svg>
              </div>

              <template v-if="showConfirmSubMenu">
                <div class="context-menu-item sub-item" @click="enviar_confirmacion_email()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                  Confirmación EMAIL/correo
                </div>
                <div class="context-menu-item sub-item" @click="enviar_confirmacion_whatsapp()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="#25D366">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.94 3.659 1.437 5.634 1.437h.005c6.558 0 11.894-5.335 11.897-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                  Confirmación WhatsApp
                </div>
              </template>

              <div class="context-menu-item" @click="copiar_link_pago()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                Enviar Link de Pago
              </div>

              <div class="context-menu-item" @click="copiar_orden()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
                Copiar Atención
              </div>

              <div class="context-menu-item" @click="goto_modificar()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                </svg>
                Modificar Atención
              </div>

              <div class="context-menu-item" @click="goto_receta()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14,2 14,8 20,8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                </svg>
                Detalles de la Atención
              </div>

              <div class="context-menu-item" @click="open()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
                Comentar
              </div>

              <div class="context-menu-item" @click="cambiar_profesional_abrir()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                Cambiar profesional o horario
              </div>

              <div class="context-menu-item" @click="openRecetasModal">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14,2 14,8 20,8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                </svg>
                Gestionar recetas
              </div>

              <div class="context-menu-item danger" @click="eliminarOrden()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="3,6 5,6 21,6"></polyline>
                  <path d="M19,6v14a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V6m3,0V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V6"></path>
                </svg>
                Eliminar Atención
              </div>
            </template>
          </div>

          <!-- Orders Table/Cards Container -->
          <div class="orders-container">
            <div v-if="!cargando_ordenes" class="orders-content-wrapper">
              <!-- Desktop Table View -->
              <div class="table-view desktop-only">
                <div class="table-container scroll-div" ref="tableContainer" @mousedown="startDragging"
                  @mouseleave="stopDragging" :class="{ dragging: isDragging }">
                  <table class="orders-table">
                    <thead>
                      <tr>
                        <th v-if="c1 == 'true'" @click="ordenar_por('id')" class="sortable">
                          <div class="th-content">
                            <span>ID</span>
                            <div class="sort-icon">
                              <svg v-if="ordenar_por_selected == 'id'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="ordenar_por_selected == 'idr'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c1 == 'true'" @click="ordenar_por('prestador')" class="sortable">
                          <div class="th-content">
                            <span>Prestador Dueño</span>
                            <div class="sort-icon">
                              <svg v-if="ordenar_por_selected == 'prestador'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="ordenar_por_selected == 'prestadorr'" width="16" height="16"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c1 == 'true'" @click="ordenar_por('prestador_tomador')" class="sortable">
                          <div class="th-content">
                            <span>Prestador Tomador</span>
                            <div class="sort-icon">
                              <svg v-if="
                                ordenar_por_selected == 'prestador_tomador'
                              " width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="
                                ordenar_por_selected == 'prestador_tomadorr'
                              " width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c18 == 'true'" @click="ordenar_por('profesional_id')" class="sortable">
                          <div class="th-content">
                            <span>Profesional</span>
                            <div class="sort-icon">
                              <svg v-if="ordenar_por_selected == 'profesional_id'" width="16" height="16"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="
                                ordenar_por_selected == 'profesional_idr'
                              " width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c2 == 'true'" @click="ordenar_por('dia')" class="sortable">
                          <div class="th-content">
                            <span>Fecha</span>
                            <div class="sort-icon">
                              <svg v-if="ordenar_por_selected == 'dia'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="ordenar_por_selected == 'diar'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c3 == 'true'" @click="ordenar_por('nombre')" class="sortable">
                          <div class="th-content">
                            <span>Nombre</span>
                            <div class="sort-icon">
                              <svg v-if="ordenar_por_selected == 'nombre'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="ordenar_por_selected == 'nombrer'" width="16" height="16"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c4 == 'true'" @click="ordenar_por('rut')" class="sortable">
                          <div class="th-content">
                            <span>RUT</span>
                            <div class="sort-icon">
                              <svg v-if="ordenar_por_selected == 'rut'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="ordenar_por_selected == 'rutr'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c5 == 'true'" @click="ordenar_por('email')" class="sortable">
                          <div class="th-content">
                            <span>Email</span>
                            <div class="sort-icon">
                              <svg v-if="ordenar_por_selected == 'email'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="ordenar_por_selected == 'emailr'" width="16" height="16"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c24 == 'true'">Fecha de nacimiento</th>
                        <th v-if="c25 == 'true'">Órdenes médicas</th>

                        <th v-if="c6 == 'true'" @click="ordenar_por('telefono')" class="sortable">
                          <div class="th-content">
                            <span>Teléfono</span>
                            <div class="sort-icon">
                              <svg v-if="ordenar_por_selected == 'telefono'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="ordenar_por_selected == 'telefonor'" width="16" height="16"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c7 == 'true'" @click="ordenar_por('monto')" class="sortable">
                          <div class="th-content">
                            <span>Monto</span>
                            <div class="sort-icon">
                              <svg v-if="ordenar_por_selected == 'monto'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="ordenar_por_selected == 'montor'" width="16" height="16"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c8 == 'true'" @click="ordenar_por('descuento')" class="sortable">
                          <div class="th-content">
                            <span>Descuento</span>
                            <div class="sort-icon">
                              <svg v-if="ordenar_por_selected == 'descuento'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="ordenar_por_selected == 'descuentor'" width="16" height="16"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c19 == 'true'" @click="ordenar_por('monto_recargo')" class="sortable">
                          <div class="th-content">
                            <span>Recargo</span>
                            <div class="sort-icon">
                              <svg v-if="ordenar_por_selected == 'monto_recargo'" width="16" height="16"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="
                                ordenar_por_selected == 'monto_recargor'
                              " width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c9 == 'true'" @click="ordenar_por('desde')" class="sortable">
                          <div class="th-content">
                            <span>Horario</span>
                            <div class="sort-icon">
                              <svg v-if="ordenar_por_selected == 'desde'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="ordenar_por_selected == 'desder'" width="16" height="16"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c10 == 'true'" @click="ordenar_por('estado')" class="sortable">
                          <div class="th-content">
                            <span>Estado</span>
                            <div class="sort-icon">
                              <svg v-if="ordenar_por_selected == 'estado'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="ordenar_por_selected == 'estador'" width="16" height="16"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c22 == 'true'" @click="ordenar_por('contactado_whatsapp')" class="sortable">
                          <div class="th-content">
                            <span>Autoconfirmación</span>
                            <div class="sort-icon">
                              <svg v-if="
                                ordenar_por_selected == 'contactado_whatsapp'
                              " width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="
                                ordenar_por_selected == 'contactado_whatsappr'
                              " width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c11 == 'true'">Pagado</th>
                        <th v-if="c23 == 'true'">Monto Pagado</th>
                        <th v-if="c20 == 'true'">Resultados</th>
                        <th v-if="c12 == 'true'">Receta Médica</th>

                        <th v-if="c13 == 'true'" @click="ordenar_por('comuna_id')" class="sortable">
                          <div class="th-content">
                            <span>Comuna</span>
                            <div class="sort-icon">
                              <svg v-if="ordenar_por_selected == 'comuna_id'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="ordenar_por_selected == 'comuna_idr'" width="16" height="16"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c14 == 'true'" @click="ordenar_por('direccion')" class="sortable">
                          <div class="th-content">
                            <span>Dirección</span>
                            <div class="sort-icon">
                              <svg v-if="ordenar_por_selected == 'direccion'" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                              </svg>
                              <svg v-else-if="ordenar_por_selected == 'direccionr'" width="16" height="16"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="18,15 12,9 6,15"></polyline>
                              </svg>
                            </div>
                          </div>
                        </th>

                        <th v-if="c15 == 'true'">Comentarios</th>
                        <th v-if="
                          (c26 == 'true' && prestador.id == 14) ||
                          prestador.id === 3 ||
                          prestador.id === 1 ||
                          prestador.id === 5
                        ">
                          Información Adicional
                        </th>
                        <th v-if="c16 == 'true'">Historial</th>
                        <th v-if="c17 == 'true'">Exámenes</th>
                        <th v-if="c21 == 'true'">Atributos</th>
                        <th v-for="(column, index) in dynamicColumns" :key="'dynamic-' + index" :style="column.style_header != undefined
                            ? column.style_header
                            : {}
                          ">
                          {{ column.header }}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(o, idx) in ordenes_calculated" v-if="mostrar_orden(o)" :key="idx" class="table-row"
                        :class="{
                          urgent: o.urgente && o.estado == 1,
                          inactive: o.estado == 0
                        }" @click="
                          mouseEnter(
                            $event,
                            o.id,
                            timeConvert(o.desde),
                            timeConvert(o.hasta),
                            o.profesional
                          )
                          ">
                        <td v-if="c1 == 'true'" class="cell-id">{{ o.id }}</td>

                        <td v-if="c1 == 'true'" class="cell-provider">
                          <span :class="o.orden_propia
                              ? 'provider-own'
                              : 'provider-external'
                            ">
                            {{ o.prestador }}
                          </span>
                        </td>

                        <td v-if="c1 == 'true'" class="cell-provider">
                          <span :class="o.orden_tomada
                              ? 'provider-own'
                              : 'provider-external'
                            ">
                            {{ o.prestador_tomador }}
                          </span>
                        </td>

                        <td v-if="c18 == 'true'" class="cell-professional">
                          <span :class="o.profesional != null
                              ? 'professional-assigned'
                              : 'professional-unassigned'
                            ">
                            {{
                              o.profesional != null
                                ? o.profesional.nombre +
                                " " +
                                o.profesional.apellido
                                : "SIN ASIGNAR"
                            }}
                          </span>
                        </td>

                        <td v-if="c2 == 'true'" class="cell-date">
                          <div class="date-content">
                            {{
                              new Date(
                                o.fecha.a,
                                o.fecha.m - 1,
                                o.fecha.d
                              ).toLocaleDateString("es-ES", {
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                              })
                            }}
                            <button class="copy-btn no-menu" :style="{
                              color: prestador.admin.assets.colors.secondary
                            }" @click="
                                copyContent(
                                  new Date(
                                    o.fecha.a,
                                    o.fecha.m - 1,
                                    o.fecha.d
                                  ).toLocaleDateString('es-ES', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                  })
                                )
                                ">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                              </svg>
                            </button>
                          </div>
                        </td>

                        <td v-if="c3 == 'true'" class="cell-client">
                          <div v-for="cl in o.clientes" class="client-item">
                            <div class="client-name">
                              {{ cl.nombre }} {{ cl.apellido1 }}
                              {{ cl.apellido2 }}
                              <button class="copy-btn no-menu" :style="{
                                color: prestador.admin.assets.colors.secondary
                              }" @click="
                                  copyContent(cl.nombre + ' ' + cl.apellido1)
                                  ">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                  stroke-width="2">
                                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                </svg>
                              </button>
                            </div>
                            <div class="insurance-badge">
                              ({{
                                aseguradoras.find(x => x.id == cl.id_asegurador)
                                  .nombre
                              }})
                            </div>
                          </div>
                        </td>

                        <td v-if="c4 == 'true'" class="cell-rut">
                          <div v-for="cl in o.clientes" class="rut-item">
                            {{ cl.rut }}
                            <button class="copy-btn no-menu" :style="{
                              color: prestador.admin.assets.colors.secondary
                            }" @click="copyContent(cl.rut)">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                              </svg>
                            </button>
                          </div>
                        </td>

                        <td v-if="c5 == 'true'" class="cell-email">
                          <div v-for="cl in o.clientes" class="email-item">
                            {{ cl.email }}
                            <button class="copy-btn no-menu" :style="{
                              color: prestador.admin.assets.colors.secondary
                            }" @click="copyContent(cl.email)">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                              </svg>
                            </button>
                          </div>
                        </td>

                        <td v-if="c24 == 'true'">
                          <div v-for="cl in o.clientes">
                            {{
                              new Date(cl.fecha_nacimiento).toLocaleDateString()
                            }}
                            <button class="copy-btn no-menu" :style="{
                              color: prestador.admin.assets.colors.secondary
                            }" @click="
                                copyContent(
                                  new Date(
                                    cl.fecha_nacimiento
                                  ).toLocaleDateString()
                                )
                                ">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                              </svg>
                            </button>
                          </div>
                        </td>

                        <td v-if="c25 == 'true'">
                          <template v-for="cl in o.clientes" v-if="o.recetas.find(z => z.cliente_id == cl.id)">
                            Para <strong>{{ cl.nombre }}</strong>
                            <div class="prescription-link" :style="{
                              color: prestador.admin.assets.colors.primary
                            }" v-for="(rec, indx) in o.recetas.filter(
                                x => x.cliente_id == cl.id
                              )" @click="fetchAndClickLink(rec.id)">
                              ({{ indx + 1 }})
                            </div>
                          </template>
                        </td>

                        <td v-if="c6 == 'true'" class="cell-phone">
                          <div v-for="cl in o.clientes" class="phone-item">
                            {{ cl.telefono }}
                            <button class="copy-btn no-menu" :style="{
                              color: prestador.admin.assets.colors.secondary
                            }" @click="copyContent(cl.telefono)">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                              </svg>
                            </button>
                          </div>
                        </td>

                        <td v-if="c7 == 'true'" class="cell-amount">
                          <span class="amount-value">${{
                            Intl.NumberFormat("de-DE").format(o.monto)
                          }}</span>
                        </td>

                        <td v-if="c8 == 'true'" class="cell-discount">
                          <span class="discount-value">${{
                            Intl.NumberFormat("de-DE").format(o.descuento)
                          }}</span>
                        </td>

                        <td v-if="c19 == 'true'" class="cell-surcharge">
                          <span class="surcharge-value">${{
                            Intl.NumberFormat("de-DE").format(o.monto_recargo)
                          }}</span>
                        </td>

                        <td v-if="c9 == 'true'" class="cell-schedule">
                          <span class="schedule-text">{{ timeConvert(o.desde) }}-{{
                            timeConvert(o.hasta)
                          }}</span>
                        </td>

                        <td v-if="c10 == 'true'" class="cell-status">
                          <select v-model="o.estado" class="status-select no-menu"
                            @change="cambiarEstado2(o.id, o.estado)">
                            <option v-for="(e, z) in estados" :value="z">{{
                              e
                              }}</option>
                          </select>
                        </td>

                        <td v-if="c22 == 'true'" class="cell-contact">
                          <div class="contact-badge" v-if="o.contactado_whatsapp == 1" :style="{
                            'background-color':
                              prestador.admin.assets.colors.secondary
                          }">
                            Se le envió el primer correo
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2">
                              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                              <polyline points="14,2 14,8 20,8"></polyline>
                            </svg>
                          </div>
                          <div class="contact-badge" v-else-if="o.contactado_whatsapp == 2" :style="{
                            'background-color':
                              prestador.admin.assets.colors.secondary
                          }">
                            Se le envió el segundo correo
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2">
                              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                              <polyline points="14,2 14,8 20,8"></polyline>
                            </svg>
                          </div>
                          <div class="contact-badge whatsapp" v-else-if="o.contactado_whatsapp == 3" :style="{
                            'background-color':
                              prestador.admin.assets.colors.primary
                          }">
                            Se le envió un Whatsapp
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2">
                              <path
                                d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z">
                              </path>
                            </svg>
                          </div>
                          <div class="contact-badge no-contact" v-else>
                            No se ha contactado
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2">
                              <circle cx="12" cy="12" r="10"></circle>
                              <line x1="15" y1="9" x2="9" y2="15"></line>
                              <line x1="9" y1="9" x2="15" y2="15"></line>
                            </svg>
                          </div>
                        </td>

                        <td v-if="c11 == 'true'" class="cell-paid">
                          <div class="status-icon">
                            <svg v-if="o.pagado == 1" width="20" height="20" viewBox="0 0 24 24" fill="none"
                              stroke="currentColor" stroke-width="2" class="icon-success">
                              <polyline points="20,6 9,17 4,12"></polyline>
                            </svg>
                            <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2" class="icon-error">
                              <circle cx="12" cy="12" r="10"></circle>
                              <line x1="15" y1="9" x2="9" y2="15"></line>
                              <line x1="9" y1="9" x2="15" y2="15"></line>
                            </svg>
                          </div>
                        </td>

                        <td v-if="c23 == 'true'" class="cell-paid-amount">
                          <span class="paid-amount-value">${{
                            Intl.NumberFormat("de-DE").format(o.monto_pagado)
                          }}</span>
                        </td>

                        <td v-if="c20 == 'true'" class="cell-results">
                          <div class="status-icon">
                            <svg v-if="
                              o.clientes.reduce((x, y) => {
                                return x + y.resultados.length;
                              }, 0) > 0
                            " width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2" class="icon-success">
                              <polyline points="20,6 9,17 4,12"></polyline>
                            </svg>
                            <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2" class="icon-error">
                              <circle cx="12" cy="12" r="10"></circle>
                              <line x1="15" y1="9" x2="9" y2="15"></line>
                              <line x1="9" y1="9" x2="15" y2="15"></line>
                            </svg>
                          </div>
                        </td>

                        <td v-if="c12 == 'true'" class="cell-prescription">
                          <div class="status-icon">
                            <svg v-if="
                              !requierenReceta(
                                o.examenes,
                                o.clientes,
                                o.recetas
                              )
                            " width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2" class="icon-success">
                              <polyline points="20,6 9,17 4,12"></polyline>
                            </svg>
                            <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2" class="icon-error">
                              <circle cx="12" cy="12" r="10"></circle>
                              <line x1="15" y1="9" x2="9" y2="15"></line>
                              <line x1="9" y1="9" x2="15" y2="15"></line>
                            </svg>
                          </div>
                        </td>

                        <td v-if="c13 == 'true'" class="cell-commune">
                          {{
                            comunas.filter(x => {
                              return x.id == o.comuna_id;
                            })[0].Nombre
                          }}
                        </td>

                        <td v-if="c14 == 'true'" class="cell-address">
                          <div class="address-content">
                            {{ o.direccion }} ({{
                              o.departamento == 1
                                ? "Departamento " + o.n_depto
                                : "Casa"
                            }})
                            <button class="copy-btn no-menu" :style="{
                              color: prestador.admin.assets.colors.secondary
                            }" @click="
                                copyContent(
                                  o.direccion +
                                  ' (' +
                                  (o.departamento == 1
                                    ? 'Departamento ' + o.n_depto
                                    : 'Casa') +
                                  ')'
                                )
                                ">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                              </svg>
                            </button>
                          </div>
                        </td>

                        <td v-if="c15 == 'true'" class="cell-comments">
                          <div class="comments-content">
                            <div v-for="(c, i) in o.comentarios
                              .slice()
                              .filter(x => {
                                return x.tipo == 2;
                              })
                              .sort(compareDt)" v-if="i < 1 || o.viendoComentarios" class="comment-item">
                              <span v-if="c.autor != null">
                                <button v-if="admin_datos.id == c.autor.id" class="delete-comment-btn no-menu"
                                  @click="eliminarComentario(c.id)">
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2">
                                    <polyline points="3,6 5,6 21,6"></polyline>
                                    <path
                                      d="M19,6v14a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V6m3,0V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V6">
                                    </path>
                                  </svg>
                                </button>
                              </span>
                              <div class="comment-header">
                                <strong>{{
                                  new Date(
                                    c.fecha.a,
                                    c.fecha.m - 1,
                                    c.fecha.d,
                                    c.fecha.h,
                                    c.fecha.min
                                  ).toLocaleDateString("es-ES", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric"
                                  })
                                }}</strong>
                                por
                                {{
                                  c.autor != null
                                    ? c.autor.nombre
                                    : "Sin Autor"
                                }}:
                              </div>
                              <div class="comment-text">{{ c.texto }}</div>
                            </div>
                            <button v-if="
                              o.comentarios.slice().filter(x => {
                                return x.tipo == 2;
                              }).length > 1
                            " class="toggle-comments-btn no-menu" :style="{
                                'background-color':
                                  prestador.admin.assets.colors.secondary
                              }" @click="
                                o.viendoComentarios = !o.viendoComentarios;
                              $forceUpdate();
                              ">
                              {{
                                o.viendoComentarios ? "Esconder" : "Mostrar más"
                              }}
                            </button>
                          </div>
                        </td>

                        <td v-if="
                          (c26 == 'true' && prestador.id == 14) ||
                          prestador.id === 3 ||
                          prestador.id === 1 ||
                          prestador.id === 5
                        " class="cell-additional-info">
                          <div v-for="cl in o.clientes" class="additional-info-item">
                            {{ cl.atributos.razon }}
                            <span class="info-badge">{{
                              cl.atributos.sintomas
                              }}</span>
                            <button class="copy-btn no-menu" :style="{
                              color: prestador.admin.assets.colors.secondary
                            }" @click="copyContent(cl.email)">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                              </svg>
                            </button>
                          </div>
                          <button v-if="o.informacion_adicional" class="copy-btn no-menu" :style="{
                            color: prestador.admin.assets.colors.secondary
                          }" @click="copyContent(o.informacion_adicional)">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2">
                              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                            </svg>
                          </button>
                        </td>

                        <td v-if="c16 == 'true'" class="cell-history">
                          <div class="history-content">
                            <div v-for="(c, i) in o.comentarios
                              .slice()
                              .filter(x => {
                                return x.tipo == 1;
                              })
                              .sort(compareDt)" v-if="i < 1 || o.viendoHistorial" class="history-item">
                              <div class="history-date">
                                <strong>{{
                                  new Date(
                                    c.fecha.a,
                                    c.fecha.m - 1,
                                    c.fecha.d
                                  ).toLocaleDateString("es-ES", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric"
                                  })
                                }}:</strong>
                              </div>
                              <div class="history-text">{{ c.texto }}</div>
                            </div>
                            <div class="history-toggle">
                              <button v-if="
                                o.comentarios.slice().filter(x => {
                                  return x.tipo == 1;
                                }).length > 1
                              " class="toggle-history-btn no-menu" :style="{
                                  'background-color':
                                    prestador.admin.assets.colors.secondary
                                }" @click="
                                  o.viendoHistorial = !o.viendoHistorial;
                                $forceUpdate();
                                ">
                                {{
                                  o.viendoHistorial
                                    ? "Esconder historial"
                                    : "Mostrar Historial"
                                }}
                              </button>
                            </div>
                          </div>
                        </td>

                        <td v-if="c17 == 'true'" class="cell-exams">
                          <div v-for="e in o.examenes" class="exam-item">
                            <span class="exam-quantity">{{ e.cantidad }}x</span>
                            <span class="exam-name">{{ e.nombre }}</span>
                            <span v-if="e.codigo != null" class="exam-code">({{ e.codigo }})</span>
                          </div>
                        </td>

                        <td v-if="c21 == 'true'" class="cell-attributes">
                          <div v-if="o.atributos && Object.keys(o.atributos).length != 0" class="attributes-content">
                            
                            <span v-for="key_ in Object.keys(o.atributos)" :key="key_" class="attribute-item">
                              
                              <template v-if="o.atributos[key_] !== undefined && o.atributos[key_] !== null && o.atributos[key_] !== ''">
                                <strong>
                                  {{ 
                                    key_ === 'devolucion' ? 'Devolución' :
                                    key_ === 'figura_pago' ? 'Método de Pago' :
                                    key_ === 'ingreso' ? 'Portal de Ingreso' :
                                    key_ === 'nuevo_sp' ? 'Nuevo SP' : 
                                    key_ === 'config_id' ? 'Configuración' :
                                    key_ 
                                  }}:
                                </strong>
                                {{ o.atributos[key_] }}
                              </template>

                            </span>
                          </div>
                          <span v-else class="no-attributes">No tiene</span>
                        </td>

                        <td v-for="(column, index) in dynamicColumns" :key="'dynamic-' + index" class="cell-dynamic">
                          <div class="no-menu" v-if="column.type === 'text'">
                            <input class="no-menu dynamic-input" v-model="o.atributos[column.field]" type="text" @input="
                              debouncedUpdateField(
                                idx,
                                column.field,
                                $event.target.value
                              )
                              " />
                          </div>
                          <div class="no-menu cell-content" v-else-if="column.type === 'select'">
                            <select class="no-menu dynamic-select" v-model="o.atributos[column.field]" @input="
                              updateField(
                                idx,
                                column.field,
                                $event.target.value
                              )
                              ">
                              <option v-for="option in column.options" :key="option" :value="option">{{ option }}
                              </option>
                            </select>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Mobile Card View -->
              <div class="mobile-view">
                <div class="orders-cards">
                  <div v-for="(o, idx) in ordenes_calculated" v-if="mostrar_orden(o)" :key="idx" class="order-card"
                    :class="{
                      urgent: o.urgente && o.estado == 1,
                      inactive: o.estado == 0
                    }" @click="
                      mouseEnter(
                        $event,
                        o.id,
                        timeConvert(o.desde),
                        timeConvert(o.hasta),
                        o.profesional
                      )
                      ">
                    <div class="card-header">
                      <div class="card-id">
                        <span class="id-badge">#{{ o.id }}</span>
                        <span v-if="o.urgente && o.estado == 1" class="urgent-badge">URGENTE</span>
                      </div>
                      <div class="card-date">
                        {{
                          new Date(
                            o.fecha.a,
                            o.fecha.m - 1,
                            o.fecha.d
                          ).toLocaleDateString("es-ES", {
                            year: "numeric",
                            month: "short",
                            day: "numeric"
                          })
                        }}
                      </div>
                    </div>

                    <div class="card-body">
                      <div class="patient-info">
                        <div v-for="cl in o.clientes" class="patient-item">
                          <h4 class="patient-name">
                            {{ cl.nombre }} {{ cl.apellido1 }}
                            {{ cl.apellido2 }}
                          </h4>
                          <div class="patient-details">
                            <span class="patient-rut">{{ cl.rut }}</span>
                            <span class="patient-phone">{{ cl.telefono }}</span>
                          </div>
                          <div class="insurance-info">
                            {{
                              aseguradoras.find(x => x.id == cl.id_asegurador)
                                .nombre
                            }}
                          </div>
                        </div>
                      </div>

                      <div class="appointment-info">
                        <div class="info-row">
                          <div class="info-item">
                            <span class="info-label">Profesional:</span>
                            <span :class="o.profesional != null
                                ? 'info-value'
                                : 'info-value-missing'
                              ">
                              {{
                                o.profesional != null
                                  ? o.profesional.nombre +
                                  " " +
                                  o.profesional.apellido
                                  : "SIN ASIGNAR"
                              }}
                            </span>
                          </div>
                        </div>

                        <div class="info-row">
                          <div class="info-item">
                            <span class="info-label">Horario:</span>
                            <span class="info-value">{{ timeConvert(o.desde) }}-{{
                              timeConvert(o.hasta)
                            }}</span>
                          </div>
                        </div>

                        <div class="info-row">
                          <div class="info-item">
                            <span class="info-label">Monto:</span>
                            <span class="info-value amount">${{
                              Intl.NumberFormat("de-DE").format(o.monto)
                            }}</span>
                          </div>
                        </div>

                        <div class="info-row">
                          <span>Prestador Dueño</span>
                          <div class="info-item">
                            {{ o.prestador }}
                          </div>
                        </div>

                        <div class="info-row">
                          <span>Prestador Tomador</span>
                          <div class="info-item">
                            {{ o.prestador_tomador }}
                          </div>
                        </div>

                        <div class="info-row">
                          <div class="info-item full-width">
                            <span class="info-label">Estado:</span>
                            <select v-model="o.estado" class="mobile-status-select no-menu"
                              @change="cambiarEstado2(o.id, o.estado)">
                              <option v-for="(e, z) in estados" :value="z">{{
                                e
                                }}</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div class="card-badges">
                        <div class="status-badges">
                          <span v-if="o.pagado == 1" class="status-badge paid">Pagado</span>
                          <span v-else class="status-badge unpaid">No Pagado</span>

                          <span v-if="
                            o.clientes.reduce((x, y) => {
                              return x + y.resultados.length;
                            }, 0) > 0
                          " class="status-badge results">Con Resultados</span>
                          <span v-else class="status-badge no-results">Sin Resultados</span>

                          <span v-if="
                            !requierenReceta(
                              o.examenes,
                              o.clientes,
                              o.recetas
                            )
                          " class="status-badge prescription-ok">Receta OK</span>
                          <span v-else class="status-badge prescription-needed">Receta Requerida</span>
                        </div>
                      </div>

                      <div v-if="c17 == 'true'" class="exams-section">
                        <h5 class="section-title">Exámenes:</h5>
                        <div class="exams-list">
                          <div v-for="e in o.examenes" class="exam-item-mobile">
                            <span class="exam-quantity">{{ e.cantidad }}x</span>
                            <span class="exam-name">{{ e.nombre }}</span>
                            <span v-if="e.codigo != null" class="exam-code">({{ e.codigo }})</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Loading State -->
            <div v-else class="loading-container">
              <div class="loading-content">
                <Loader :height="100" :width="100" />
                <p class="loading-text">Cargando órdenes médicas...</p>
              </div>
            </div>
          </div>

          <div v-if="comentando" class="modal-simple">
            <div class="modal-contenido">
              <h3>Comentar orden #{{ id_orden }}</h3>
              <textarea v-model="comentario" placeholder="Escribe tu comentario..."></textarea>
              <div class="modal-botones">
                <button @click="comentar">Enviar</button>
                <button @click="comentando = false">Cancelar</button>
              </div>
            </div>
          </div>

          <!-- Upload Results Modal -->
          <div v-if="subiendo_resultados.subiendo" class="modal-overlay">
            <div class="modal-container upload-modal">
              <div class="modal-header">
                <h4 class="modal-title">
                  Subiendo resultados para la orden: {{ id_orden }}
                </h4>
                <button class="modal-close-btn result" @click="limpiar_subiendo_resultados()">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>

              <div class="modal-body">
                <div v-for="o in ordenes_calculated.find(z => {
                  return z.id == id_orden;
                }).clientes" :key="o.id" class="upload-client-section result">
                  <h5 class="client-name">
                    {{ o.nombre }} {{ o.apellido1 }} {{ o.apellido2 }}
                  </h5>

                  <input :id="'file' + o.id" :ref="'file' + o.id" type="file" class="file-input result"
                    accept=".pdf,.jpg,.jpeg,.png" @change="onChange(o.id)" />

                  <label :for="'file' + o.id" class="file-upload-btn result" :style="{
                    'background-color':
                      prestador.admin.assets.colors.secondary
                  }">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="11" cy="11" r="8"></circle>
                      <path d="M21 21l-4.35-4.35"></path>
                    </svg>
                    Examinar archivos
                  </label>

                  <div class="uploaded-files">
                    <div v-for="x in subiendo_resultados.resultados.filter(y => {
                      return y.cliente_id == o.id;
                    })" class="uploaded-file">
                      <span class="file-name">{{ x.resultado.name }}</span>
                      <button class="remove-file-btn result" @click="">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button class="btn-primary result" :style="{
                  'background-color': prestador.admin.assets.colors.primary
                }" @click="subir_resultados()">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="17,8 12,3 7,8"></polyline>
                    <line x1="12" y1="3" x2="12" y2="15"></line>
                  </svg>
                  Subir Resultados
                </button>
              </div>
            </div>
          </div>

          <!-- Change Professional Modal -->
          <div v-if="cambiar_profesional.cambiando" class="modal-overlay">
            <div class="modal-container professional-modal">
              <div class="modal-header">
                <h4 class="modal-title">
                  Cambiando profesional para la orden: {{ id_orden }}
                </h4>
                <button class="modal-close-btn result" @click="cambiar_profesional_cerrar()">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>

              <div class="modal-body">
                <div v-if="cambiar_profesional.cargado == true" class="professional-change-content">
                  <div class="form-section">
                    <label class="form-label">Seleccionar Profesional:</label>
                    <select v-model="cambiar_profesional.profesional" class="form-select no-menu"
                      @change="cambiar_profesional_seleccionar_profesional">
                      <option v-for="profesional in cambiar_profesional.profesionales" :key="profesional.id"
                        :value="profesional">
                        {{ profesional.nombre }} {{ profesional.apellido }}
                      </option>
                    </select>

                    <div v-if="cambiar_profesional.profesionales.length == 0" class="no-results-message">
                      No se encontraron profesionales disponibles
                    </div>
                  </div>

                  <div v-if="cambiar_profesional.profesional" class="form-section">
                    <label class="form-label">Fecha:</label>
                    <input v-model="cambiar_profesional.dt_dia" type="date" class="form-input" @change="
                      cambiar_profesional_ver_horarios_disponibles(
                        $event.target.value
                      )
                      " />
                  </div>

                  <div v-if="
                    cambiar_profesional.profesional &&
                    cambiar_profesional.horarios.length > 0
                  " class="form-section">
                    <label class="form-label">Horario:</label>
                    <select v-model="cambiar_profesional.horario" class="form-select no-menu"
                      @change="cambiar_profesional_seleccionar_horario">
                      <option v-for="horario in cambiar_profesional.horarios.filter(
                        h => {
                          return (
                            h.repeticion[
                            new Date(cambiar_profesional.dt_dia).getDay()
                            ] == '1'
                          );
                        }
                      )" :key="horario.id" :value="horario">
                        Horario {{ horario.id }} |
                        {{ minutes_to_time(horario.inicio) }} -
                        {{ minutes_to_time(horario.termino) }} | Prioridad
                        {{ horario.prioridad }}
                      </option>
                    </select>
                  </div>

                  <div v-else-if="
                    cambiar_profesional.profesional &&
                    cambiar_profesional.horario.length == 0
                  " class="no-results-message">
                    No se encontraron horarios disponibles
                  </div>

                  <div v-if="
                    cambiar_profesional.profesional &&
                    cambiar_profesional.horario &&
                    cambiar_profesional.horas.length > 0
                  " class="form-section">
                    <label class="form-label">Hora disponible:</label>
                    <select v-model="cambiar_profesional.hora" class="form-select no-menu">
                      <option v-for="(hora, key) in cambiar_profesional.horas" :key="key" :value="{
                        desde: hora.start_time,
                        hasta: hora.end_time
                      }">
                        {{ hora.start_time }} - {{ hora.end_time }}
                      </option>
                    </select>
                  </div>

                  <div v-else-if="
                    cambiar_profesional.profesional &&
                    cambiar_profesional.horario &&
                    cambiar_profesional.horas.length == 0 &&
                    !cambiar_profesional.forzado
                  " class="force-change-section">
                    <div class="no-results-message">
                      No se encontraron horas disponibles
                    </div>
                    <button @click="
                      cambiar_profesional.forzado = true;
                    $forceUpdate();
                    " :style="{
                        'background-color':
                          prestador.admin.assets.colors.primary
                      }" class="btn-secondary">
                      Forzar cambio
                    </button>
                  </div>

                  <div v-else-if="
                    cambiar_profesional.profesional &&
                    cambiar_profesional.horario &&
                    cambiar_profesional.horas.length == 0 &&
                    cambiar_profesional.forzado
                  " class="form-section">
                    <label class="form-label">Hora forzada:</label>
                    <select v-model="cambiar_profesional.hora" class="form-select no-menu">
                      <option v-for="(hora, key) in (cambiar_profesional.horario
                        .termino -
                        cambiar_profesional.horario.inicio) /
                        cambiar_profesional.horario.intervalo" :key="key" :value="{
                            desde: timeConvert(
                              (hora - 1) * cambiar_profesional.horario.intervalo +
                              cambiar_profesional.horario.inicio
                            ),
                            hasta: timeConvert(
                              hora * cambiar_profesional.horario.intervalo +
                              cambiar_profesional.horario.inicio
                            )
                          }">
                        {{
                          timeConvert(
                            (hora - 1) * cambiar_profesional.horario.intervalo +
                            cambiar_profesional.horario.inicio
                          )
                        }}
                        -
                        {{
                          timeConvert(
                            hora * cambiar_profesional.horario.intervalo +
                            cambiar_profesional.horario.inicio
                          )
                        }}
                      </option>
                    </select>
                  </div>

                  <div v-if="
                    cambiar_profesional.profesional &&
                    cambiar_profesional.horario &&
                    (cambiar_profesional.horas.length > 0 ||
                      cambiar_profesional.forzado) &&
                    cambiar_profesional.hora
                  " class="comparison-table">
                    <h5 class="comparison-title">Resumen de cambios:</h5>
                    <table class="comparison-table-content">
                      <thead>
                        <tr>
                          <th>Aspecto</th>
                          <th>Nuevo</th>
                          <th>Antiguo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td><strong>Profesional</strong></td>
                          <td>
                            {{ cambiar_profesional.profesional.nombre }}
                            {{ cambiar_profesional.profesional.apellido }}
                          </td>
                          <td>{{ profesional }}</td>
                        </tr>
                        <tr>
                          <td><strong>Hora inicio</strong></td>
                          <td>{{ cambiar_profesional.hora.desde }}</td>
                          <td>{{ orden_desde }}</td>
                        </tr>
                        <tr>
                          <td><strong>Hora fin</strong></td>
                          <td>{{ cambiar_profesional.hora.hasta }}</td>
                          <td>{{ orden_hasta }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div v-else class="loading-state">
                  <div class="loading-content">
                    <Loader :height="60" :width="60" />
                    <p>Buscando profesionales disponibles...</p>
                  </div>
                </div>
              </div>

              <div v-if="
                cambiar_profesional.profesional &&
                cambiar_profesional.horario &&
                (cambiar_profesional.horas.length > 0 ||
                  cambiar_profesional.forzado) &&
                cambiar_profesional.hora
              " class="modal-footer">
                <button class="btn-primary" :style="{
                  'background-color': prestador.admin.assets.colors.primary
                }" @click="cambiar_orden_a_profesional">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  Cambiar profesional
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Loading State for Main Content -->
        <div v-else class="main-loading">
          <div class="loading-container">
            <div class="loading-content">
              <Loader :height="120" :width="120" />
              <p class="loading-text">Cargando sistema de atenciones...</p>
            </div>
          </div>
        </div>
      </div>
      <div class="info-banner">
        <div class="info-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
        </div>
        <div class="info-content">
          <p>
            Arrastra con el cursor para ver todas las columnas. Puedes
            <strong>clickear una atención</strong> para ver las opciones
            específicas de esa atención en particular.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import Fuse from "fuse.js";
import SideNav from "@/components/SideNav.vue";
import Loader from "@/components/Loader.vue";
import TopNav from "@/components/TopNav.vue";
import ModalFiltrosOrdenes from "@/components/utils/ModalFiltrosOrdenes.vue";
import ModalDescargarExcel from "@/components/utils/ModalDescargarExcel.vue";
import ModalCopiarOrden from "@/components/utils/ModalCopiarOrden.vue";
import ModalNuevaAgenda from "@/components/utils/ModalNuevaAgenda.vue";
import ModalRecetas from "@/components/utils/ModalRecetas.vue";
import ModalComentario from "./utils/ModalComentario.vue";

export default {
  name: "HelloWorld",
  props: ["id"],
  components: {
    SideNav,
    Loader,
    TopNav,
    ModalFiltrosOrdenes,
    ModalNuevaAgenda,
    ModalCopiarOrden,
    ModalDescargarExcel,
    ModalRecetas,
    ModalComentario
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      link: "",
      isDragging: false,
      startX: 0,
      startY: 0,
      scrollLeft: 0,
      scrollTop: 0,

      ordenar_por_selected: "id",

      subiendo_resultados: {
        orden_id: 0,
        resultados: [],
        subiendo: false
      },

      dynamicStyles: [],
      debounceTimers: {},

      cargando_ordenes: false,
      cambiar_profesional: {
        horarios_disponibles: [],
        dia_dt: "",
        cambiando: false,
        profesional: null,
        profesionales: [],
        horario: null,
        horarios: [],
        horas: [],
        hora: null,
        cargado: false,
        bloqueos: []
      },

      dynamicColumns: [],

      email: "",
      nombre: "",
      apellido: "",
      rut: "",

      profesional: "",
      orden_desde: "",
      orden_hasta: "",

      dt_dia: "",
      dt_dia2: "",

      desde: { d: 0, m: 0, a: 0 },
      hasta: { d: 0, m: 0, a: 0 },

      /*       filtros:{
              profesionales:[],
              prestador_dueño:[],
              prestador_tomador:[],
              comunas:[],
              config_id:[],
            }, */
      filtros: [
        { nombre: "Profesionales", excluidos: [] },
        { nombre: "Prestador Dueño", excluidos: [] },
        { nombre: "Prestador Tomador", excluidos: [] },
        { nombre: "Comunas", excluidos: [] },
        { nombre: "Estado", excluidos: [] },
        { nombre: "config_id", excluidos: [] }
      ],

      ordenes: [],
      ordenes_calculated: [],
      id_orden: 0,

      popup: false,
      mouseX: 0,
      mouseY: 0,
      showConfirmSubMenu: false,

      call_n: 0,

      comentando: false,
      comentario: "",

      resultado: "",
      estados: ["Anulado", "Citado", "Confirmado", "Atendido", "No Atendido"],
      menuCol: false,
      cols: [
        { nombre: "Id", var: "c1" },
        { nombre: "Fecha", var: "c2" },
        { nombre: "Nombre", var: "c3" },
        { nombre: "Rut", var: "c4" },
        { nombre: "Email", var: "c5" },
        { nombre: "Teléfono", var: "c6" },
        { nombre: "Monto", var: "c7" },
        { nombre: "Descuento", var: "c8" },
        { nombre: "Horario", var: "c9" },
        { nombre: "Estado", var: "c10" },
        { nombre: "Pagado", var: "c11" },
        { nombre: "Monto Pagado", var: "c23" },
        { nombre: "Receta Médica", var: "c12" },
        { nombre: "Comuna", var: "c13" },
        { nombre: "Dirección", var: "c14" },
        { nombre: "Comentarios", var: "c15" },
        { nombre: "Historial", var: "c16" },
        { nombre: "Exámenes", var: "c17" },
        { nombre: "Profesional", var: "c18" },
        { nombre: "Recargo", var: "c19" },
        { nombre: "Resultados", var: "c20" },
        { nombre: "Atributos", var: "c21" },
        { nombre: "Autoconfirmación", var: "c22" },
        { nombre: "Fecha de nacimiento", var: "c24" },
        { nombre: "Ordenes médicas", var: "c25" },
        { nombre: "Información Adicional", var: "c26" }
      ],

      c1: localStorage.getItem("c1") || "true",
      c2: localStorage.getItem("c2") || "true",
      c3: localStorage.getItem("c3") || "true",
      c4: localStorage.getItem("c4") || "true",
      c5: localStorage.getItem("c5") || "true",
      c6: localStorage.getItem("c6") || "true",
      c7: localStorage.getItem("c7") || "true",
      c8: localStorage.getItem("c8") || "true",
      c9: localStorage.getItem("c9") || "true",
      c10: localStorage.getItem("c10") || "true",
      c11: localStorage.getItem("c11") || "true",
      c12: localStorage.getItem("c12") || "true",
      c13: localStorage.getItem("c13") || "true",
      c14: localStorage.getItem("c14") || "true",
      c15: localStorage.getItem("c15") || "true",
      c16: localStorage.getItem("c16") || "true",
      c17: localStorage.getItem("c17") || "true",
      c18: localStorage.getItem("c18") || "true",
      c19: localStorage.getItem("c19") || "true",
      c20: localStorage.getItem("c20") || "true",
      c21: localStorage.getItem("c21") || "true",
      c22: localStorage.getItem("c22") || "true",
      c23: localStorage.getItem("c23") || "true",
      c24: localStorage.getItem("c24") || "true",
      c25: localStorage.getItem("c25") || "true",
      c26: localStorage.getItem("c26") || "true"
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    ...mapActions(["loginAdmin", "getNotificaciones"]),
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    openRecetasModal() {
      const orden = this.ordenes.find(x => x.id === this.id_orden);
      if (orden) {
        this.$refs.modalRecetas.show(orden);
      } else {
        alert("Orden no encontrada.");
      }
    },
    async handleRecetasUpdated() {
      await this.get_ordenes();
      this.openRecetasModal();
      /*  this.$forceUpdate() */
    },

    async fetchAndClickLink(recetaId) {
      try {
        const response = await axios.post(
          window.hostname + "/api/admin/ver_receta_por_id",
          { receta_id: recetaId }
        );
        this.link = response.data.link; // Adjust this based on your API response structure
        this.$nextTick(() => {
          this.$refs.hiddenLink.click();
        });
      } catch (error) {
        console.error("Error fetching the link:", error);
      }
    },
    copyToClipboard() {
      let data = this.ordenes.find(x => x.id == this.id_orden);

      const rows = data.clientes
        .map(cliente => {
          return [
            //   '', // data.estado, // NÚMERO (Assumed to be the order ID)
            data.id, // ORDEN (This can be whatever represents "ORDEN" in your data)
            new Date(
              data.fecha.a,
              data.fecha.m - 1,
              data.fecha.d
            ).toLocaleDateString(), // DÍA (formatted as DD/MM/YYYY)
            `${cliente.nombre} ${cliente.apellido1} ${cliente.apellido2}`.trim(), // PACIENTE
            new Date(cliente.fecha_nacimiento).toLocaleDateString(), // NACIMIENTO (No birthdate provided, leave blank or add if available)
            cliente.rut, // RUT
            cliente.email, // EMAIL
            cliente.telefono, // TELÉFONO
            data.examenes.map(examen => examen.nombre).join(", "), // EXÁMENES
            data.direccion +
            " (" +
            (data.departamento == 1
              ? "Departamento " + data.n_depto
              : "Casa") +
            ")", // DIRECCIÓN
            this.comunas.find(x => x.id == data.comuna_id).Nombre, // COMUNA (you may want to map ID to a name if needed)
            this.aseguradoras.find(x => x.id == cliente.id_asegurador).nombre, // PREVISIÓN (Not provided)
            this.regiones.find(
              x => x.id == this.comunas.find(x => x.id == data.comuna_id).region
            ).Nombre, // REGIÓN (Not provided)
            "", //data.monto, // COPAGO (If this is the right field, adjust if necessary)
            //'', //data.monto_pagado, // NETO
            //'', //data.atributos.ingreso, // INGRESOS
            "", // RESULTADO (Not provided, adjust if necessary)
            data.prestador, // RESULTADO (Not provided, adjust if necessary)
            new Date(data.desde * 60 * 1000).toISOString().substr(11, 5) +
            " - " +
            new Date(data.hasta * 60 * 1000).toISOString().substr(11, 5), // HORA (converted from minutes)
            data.profesional.nombre + " " + data.profesional.apellido // TOMADOR
            //data.prestador_tomador, // TOMADOR
            //data.comentarios.map(com => com.texto).join(', ') // OBSERVACIÓN
          ].join("\t");
        })
        .join("\n");

      const el = document.createElement("textarea");
      el.value = rows;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);

      this.$notify({
        group: "foo",
        title: "¡Éxito!",
        text: "¡Se copiaron los datos!",
        type: "success"
      });
    },
    copyContent(content) {
      navigator.clipboard
        .writeText(content)
        .then(() => {
          this.$notify({
            group: "foo",
            title: "¡Éxito!",
            text: "¡Se ha copiado!",
            type: "success"
          });
        })
        .catch(err => {
          console.error("Failed to copy: ", err);
        });
    },
    startDragging(e) {
      // Prevent default behavior to stop text selection
      /* e.preventDefault(); */

      this.isDragging = true;
      this.startX = e.pageX - this.$refs.tableContainer.offsetLeft;
      this.startY = e.pageY - this.$refs.tableContainer.offsetTop;
      this.scrollLeft = this.$refs.tableContainer.scrollLeft;
      this.scrollTop = this.$refs.tableContainer.scrollTop;

      document.addEventListener("mousemove", this.drag);
      document.addEventListener("mouseup", this.stopDragging);
    },
    drag(e) {
      if (!this.isDragging) return;
      /* e.preventDefault(); */

      const x = e.pageX - this.$refs.tableContainer.offsetLeft;
      const y = e.pageY - this.$refs.tableContainer.offsetTop;
      const walkX = (x - this.startX) * 1.5;
      const walkY = (y - this.startY) * 1.5;

      this.$refs.tableContainer.scrollLeft = this.scrollLeft - walkX;
      this.$refs.tableContainer.scrollTop = this.scrollTop - walkY;
    },
    stopDragging() {
      this.isDragging = false;
      document.removeEventListener("mousemove", this.drag);
      document.removeEventListener("mouseup", this.stopDragging);
    },

    ordenar_por(attributeName, is_fecha = false) {
      function f_sort_attribute(low_to_hight) {
        return function (a, b) {
          if (a[attributeName] < b[attributeName]) {
            return -low_to_hight;
          }
          if (a[attributeName] > b[attributeName]) {
            return low_to_hight;
          }
          return 0;
        };
      }

      if (
        this.ordenar_por_selected != attributeName ||
        this.ordenar_por_selected == attributeName + "r"
      ) {
        this.ordenar_por_selected = attributeName;
        return this.ordenes_calculated.sort(f_sort_attribute(1));
      }
      this.ordenar_por_selected = attributeName + "r";
      return this.ordenes_calculated.sort(f_sort_attribute(-1));
    },
    updateField(rowIndex, field, value) {
      // Update the local table data
      //this.$set(this.tableData[rowIndex], field, value);
      /*       this.ordenes_calculated[rowIndex].atributos[field] = value;
            this.$forceUpdate() */
      // Prepare the data to send to the backend
      const updatedData = {
        orden_id: this.ordenes_calculated[rowIndex].id, // Assuming each row has a unique ID
        field: field,
        value: value
      };

      // Make the API request to save the updated data
      axios
        .post(window.hostname + "/api/admin/update_dynamic_column", updatedData)
        .then(response => {
        })
        .catch(error => {
          console.error("Error updating field:", error);
        });
    },
    debounce(func, delay) {
      let timerId;
      return function (...args) {
        const context = this;
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(() => {
          func.apply(context, args);
        }, delay);
      };
    },
    debouncedUpdateField(rowIndex, field, value) {
      // Using the debounce method directly in the component instance context
      const debouncedFunc = this.debounce(this.updateField, 500);
      debouncedFunc.call(this, rowIndex, field, value);
    },
    pantalla_completa() {
      console.log('pantalla_completa ejecutado');

      if (!this.dynamicStyles || this.dynamicStyles.length === 0) {
        this.addDynamicStyles(`
      .medical-sidebar-container {
        width: 0%;
      }
      /* Ocultar el menú lateral - SELECTORES CORRECTOS */
      .column-left {
        display: none !important;
        width: 0 !important;
        transform: translateX(-100%) !important;
        visibility: hidden !important;
      }
      
      /* Expandir el área principal - SELECTORES CORRECTOS */
      .column-right {
        margin-left: 0 !important;
        padding-left: 0 !important;
        width: 100vw !important;
        max-width: 100vw !important;
        flex: 0 0 100vw !important;
      }
      
      /* Ajustar contenedores principales */
      .main-container {
        width: 100vw !important;
        max-width: 100vw !important;
        padding: 0 !important;
        margin: 0 !important;
      }
      
      .orders-container {
        width: 100vw !important;
        max-width: 100vw !important;
        padding: 0 20px 20px 20px !important;
        margin: 0 !important;
      }
      
      /* Tabla responsiva */
      .table-view {
        width: 100vw !important;
        overflow-x: auto !important;
      }
      
      .orders-table {
        width: max-content !important;
        min-width: 100% !important;
      }
      
      .table-container {
        width: 100vw !important;
        overflow-x: auto !important;
      }
      
      /* Header y controles */
      .page-header {
        width: 100vw !important;
        padding: 10px 20px !important;
        margin: 0 !important;
      }
      
      .controls-section {
        width: 100vw !important;
        padding: 10px 20px !important;
        margin: 0 !important;
      }
      
      /* Ocultar elementos no necesarios */
      .info-banner {
        display: none !important;
      }
      
      /* Scroll */
      body {
        overflow-x: hidden !important;
      }
      
      /* Anular media queries en modo pantalla completa */
      @media (max-width: 1200px) {
        .column-right {
          padding-left: 0 !important;
          margin-left: 0 !important;
        }
      }
      
      @media (max-width: 1024px) {
        .column-right {
          margin-left: 0 !important;
          padding-left: 0 !important;
        }
      }
    `);
        console.log('Estilos de pantalla completa aplicados');
      } else {
        this.removeDynamicStyles();
        console.log('Estilos de pantalla completa removidos');
      }
    },

    addDynamicStyles(cssContent) {
      const style = document.createElement("style");
      style.type = "text/css";
      style.setAttribute('id', 'fullscreen-styles'); // Agregar ID para mejor control
      style.appendChild(document.createTextNode(cssContent));
      document.head.appendChild(style);

      // Asegurar que dynamicStyles existe y es reactivo
      if (!this.dynamicStyles) {
        this.dynamicStyles = [];
      }
      this.dynamicStyles.push(style);

      console.log('Estilos agregados, length:', this.dynamicStyles.length);
    },

    removeDynamicStyles() {
      if (this.dynamicStyles && this.dynamicStyles.length > 0) {
        this.dynamicStyles.forEach(style => {
          if (style && style.parentNode) {
            style.parentNode.removeChild(style);
          }
        });
        this.dynamicStyles = [];
      }

      // Alternativa: remover por ID
      const existingStyle = document.getElementById('fullscreen-styles');
      if (existingStyle) {
        existingStyle.remove();
      }

      console.log('Estilos removidos');
    },
    copiar_link_pago() {
      axios
        .post(window.hostname + "/api/admin/obtener_link_pago", {
          orden_id: this.id_orden
        })
        .then(response => {
          navigator.clipboard.writeText(response.data.link);
          this.popup = false;
          this.$notify({
            group: "foo",
            title: "¡Éxito!",
            text: "¡Se ha copiado el link de pago!",
            type: "success"
          });
        })

        .catch(e => {
          console.log(e.response);
          this.popup = false;
        });
    },
    onChange(cliente_id) {
      if (
        ["jpg", "png", "jpeg", "pdf"].includes(
          this.$refs["file" + cliente_id][0].files[0].name
            .split(".")[1]
            .toLowerCase()
        )
      )
        this.subiendo_resultados.resultados.push({
          cliente_id: cliente_id,
          resultado: this.$refs["file" + cliente_id][0].files[0]
        });
    },
    getVal(x) {
      return this[x];
    },
    // setCol(x) {

    //   if (this[x] == 'true')
    //     this[x] = 'false'
    //   else
    //     this[x] = 'true'

    //   localStorage.setItem(x, this[x])

    // },
    mostrar_orden(o) {
      let filtro_profesional = this.filtros.find(
        x => x.nombre == "Profesionales"
      );
      if (o.profesional != undefined) {
        if (filtro_profesional.excluidos.includes(o.profesional.id)) {
          return false;
        }
      }

      let filtro_prestador_tomador = this.filtros.find(
        x => x.nombre == "Prestador Tomador"
      );
      if (filtro_prestador_tomador.excluidos.includes(o.prestador_tomador)) {
        return false;
      }
      let filtro_prestador_dueño = this.filtros.find(
        x => x.nombre == "Prestador Dueño"
      );
      if (filtro_prestador_dueño.excluidos.includes(o.prestador)) {
        return false;
      }
      let filtro_comunas = this.filtros.find(x => x.nombre == "Comunas");
      if (filtro_comunas.excluidos.includes(o.comuna_id)) {
        return false;
      }
      let filtro_estados = this.filtros.find(x => x.nombre == "Estado");
      if (filtro_estados.excluidos.includes(o.estado)) {
        return false;
      }
      return true;
    },
    descargarCSV() {
      const promesaDescarga = axios({
        url: window.hostname + "/api/admin/exportar_ordenes",
        method: "POST",
        responseType: "blob",
        data: {
          dia: this.desde.d,
          mes: this.desde.m,
          año: this.desde.a,
          dia2: this.hasta.d,
          mes2: this.hasta.m,
          año2: this.hasta.a
        },
        timeout: 0
      });

      Promise.allSettled([promesaDescarga]).then(resultados => {
        resultados.forEach(r => {
          if (r.status === "fulfilled") {
            const response = r.value;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "exportar.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            console.error("La descarga falló:", r.reason);
          }
        });
      });
    },
    descargarCSVPago() {
      axios({
        url: window.hostname + "/api/admin/exportar_excel_pago",
        method: "POST",
        responseType: "blob",
        data: {
          dia: this.desde.d,
          mes: this.desde.m,
          año: this.desde.a,
          dia2: this.hasta.d,
          mes2: this.hasta.m,
          año2: this.hasta.a
        }
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "exportar_pago.csv");
          document.body.appendChild(link);
          link.click();
        })
        .catch(e => {
          console.log(e);
        });
    },

    descargarOrdenesMedicas() {
      axios({
        url: window.hostname + "/api/admin/descargar_ordenes_medicas",
        method: "POST",
        data: {
          day_from: this.desde.d,
          month_from: this.desde.m,
          year_from: this.desde.a,
          day_to: this.hasta.d,
          month_to: this.hasta.m,
          year_to: this.hasta.a
        },
        responseType: "blob" // Important
      })
        .then(response => {
          if (response.data.type != "application/json") {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "ordenes_medicas.zip"); //or any other extension
            document.body.appendChild(link);
            link.click();
          } else {
            this.$notify({
              group: "foo",
              title: "¡Error!",
              text: "No hay ordenes médicas para el periodo seleccionado.",
              type: "error"
            });
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    eliminarComentario(cid) {
      axios
        .post(window.hostname + "/api/admin/eliminar_cometnario", {
          comentario_id: cid
        })
        .then(response => {
          this.get_ordenes();
          this.popup = false;
        })

        .catch(e => {
          console.log(e.response);
        });
    },
    eliminarOrden(cid) {
      axios
        .post(window.hostname + "/api/admin/borrar_orden", {
          orden_id: this.id_orden
        })
        .then(response => {
          this.get_ordenes();
          this.popup = false;
        })

        .catch(e => {
          console.log(e.response);
          this.popup = false;
        });
    },
    requierenReceta(examenes, clientes, recetas) {
      let requieren = [];
      let examen_f = [];
      for (var c of clientes) {
        for (var e of examenes.filter(x => {
          return x.cliente_id == c.id;
        })) {
          examen_f = this.examenes.filter(x => {
            return x.id == e.examen_id;
          });
          if (examen_f.length > 0) {
            if (
              this.examenes.filter(x => {
                return x.id == e.examen_id;
              })[0].requiere_orden == 1
            ) {
              requieren.push(c.id);
              break;
            }
          }
        }
        //console.log(this.examenes.filter(x=>{return x.id == e.examen_id}))
      }
      for (var c of requieren) {
        if (
          !recetas.some(l => {
            return l.cliente_id == c;
          })
        )
          return true;
      }
      return false;
    },
    cambiarEstado(e) {
      axios
        .post(window.hostname + "/api/admin/cambiarEstado", {
          orden_id: this.id_orden,
          estado_id: e
        })
        .then(response => {
          this.get_ordenes();
          this.popup = false;
        })

        .catch(e => {
          console.log(e.response);
          if (e.response.data.message) this.resultado = e.response.data.message;
        });
    },
    cambiarEstado2(o, e) {
      let orden_original = this.ordenes.find(orden => orden.id === o);
      let orden_editando = this.ordenes_calculated.find(
        orden => orden.id === o
      );
      if (e == 0) {
        if (!confirm("¿Seguro que deseas cambiar el estado a anulado?")) {
          orden_editando.estado = orden_original.estado;
          this.getNotificaciones();

          return;
        }
      }

      axios
        .post(window.hostname + "/api/admin/cambiarEstado", {
          orden_id: o,
          estado_id: e
        })
        .then(response => {
          this.get_ordenes();
          this.popup = false;
          this.$notify({
            group: "foo",
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado exitosamente!",
            type: "success"
          });
        })

        .catch(e => {
          console.log(e.response);
          this.$notify({
            group: "foo",
            title: "¡Error!",
            text: "¡Ha ocurrido un error!",
            type: "error"
          });
          if (e.response.data.message) this.resultado = e.response.data.message;
        });
    },
    comentar() {
      if (this.comentario.length <= 500) {
        axios
          .post(window.hostname + "/api/admin/hacer_comentario", {
            orden_id: 27004,
            texto: this.comentario
          })
          .then(response => {
            this.get_ordenes();
            this.comentando = false;
            this.comentario = "";
          })

          .catch(e => {
            console.log(e.response);
            if (e.response.data.message)
              this.$notify({
                group: "foo",
                title: "¡Error!",
                text: e.response.data.message,
                type: "error"
              });
            this.resultado = e.response.data.message;
          });
      }
    },
    limpiar_subiendo_resultados() {
      this.subiendo_resultados.resultados = [];
      this.subiendo_resultados.subiendo = false;
    },

    minutes_to_time(min) {
      let hora = Math.floor(min / 60);
      let minutos = min % 60;
      if (minutos < 10) minutos = `0${minutos}`;
      return `${hora}:${minutos}`;
    },

    cambiar_profesional_ver_horarios_disponibles(valor) {
      this.cambiar_profesional.horarios_disponibles = this.cambiar_profesional.horarios.filter(
        horario => {
          return horario.repeticion[new Date(valor).getDay()] == "1";
        }
      );
      this.cambiar_profesional.horario = null;
      this.$forceUpdate();
    },

    async cambiar_profesional_abrir() {
      await this.cambiar_profesional_obtener_profesionales_disponibles();
      axios
        .get(window.hostname + "/api/admin/initialize_bloqueos")
        .then(response => {
          this.cambiar_profesional.bloqueos = response.data.bloqueos;
          this.cambiar_profesional.cambiando = true;
        })
        .catch(e => {
          console.error("Error fetching blocks:", e);
          this.cambiar_profesional.cambiando = true;
        });
    },

    cambiar_profesional_cerrar() {
      this.cambiar_profesional = {
        cambiando: false,
        dt_dia: "",
        profesionales: [],
        profesional: null,
        horarios: [],
        horarios_disponibles: [],
        horario: null,
        horas: [],
        hora: null,
        cargado: false,
        bloqueos: []
      };
    },

    async cambiar_profesional_obtener_profesionales_disponibles() {
      await axios
        .get(window.hostname + "/api/admin/profesional")
        .then(response => {
          this.cambiar_profesional.profesionales = response.data;
        })
        .then(() => {
          this.cambiar_profesional.cargado = true;
        })
        .catch(e => {
          console.log(e.response);
        });
    },

    async cambiar_profesional_seleccionar_profesional() {
      let orden = this.ordenes_calculated.find(z => z.id == this.id_orden);

      this.cambiar_profesional.dt_dia = new Date(
        orden.fecha.a,
        orden.fecha.m - 1,
        orden.fecha.d
      )
        .toISOString()
        .split("T")[0];
      this.cambiar_profesional.horario = null;
      this.cambiar_profesional.horarios = [];
      this.cambiar_profesional.horas = [];
      this.cambiar_profesional.hora = null;
      this.cambiar_profesional.forzando = false;
      await this.cambiar_profesional_obtener_ordenes_disponibles();
    },

    async cambiar_profesional_obtener_ordenes_disponibles() {
      const profesional = this.cambiar_profesional.profesional.id;
      await axios
        .get(
          window.hostname + `/api/admin/horario?profesional_id=${profesional}`
        )
        .then(response => {
          this.cambiar_profesional.horarios = response.data;
        })
        .catch(e => {
          console.log(e.response);
        });
      this.cambiar_profesional_ver_horarios_disponibles(
        this.cambiar_profesional.dt_dia
      );
    },

    async cambiar_profesional_seleccionar_horario() {
      this.cambiar_profesional.horas = [];
      this.cambiar_profesional.hora = null;
      this.cambiar_profesional.forzando = false;
      await this.cambiar_profesional_obtener_horas_disponibles();
    },

    async cambiar_profesional_obtener_horas_disponibles() {
      const date = this.cambiar_profesional.dt_dia;
      const horario_id = this.cambiar_profesional.horario.id;
      await axios
        .get(
          window.hostname +
          `/api/admin/horario/bloque?date=${date}&selection=available&horario_id=${horario_id}`
        )
        .then(response => {
          this.cambiar_profesional.horas = response.data;
        })
        .catch(e => {
          console.log(e.response);
        });
    },

    isBlocked(profesional_id, dia, desdeMinutos, hastaMinutos) {
      if (!this.cambiar_profesional.bloqueos || !Array.isArray(this.cambiar_profesional.bloqueos)) {
        return false;
      }

      // Filter blocks for this professional (or global ID 0) AND this date
      const blocks = this.cambiar_profesional.bloqueos.filter(b => {
        if (!b.fecha || b.fecha.a === undefined) return false;
        const blockDate = `${b.fecha.a}-${String(b.fecha.m).padStart(2, '0')}-${String(b.fecha.d).padStart(2, '0')}`;
        const proMatch = String(b.profesional) === String(profesional_id) || String(b.profesional) === "0";
        const dateMatch = blockDate === dia;
        return proMatch && dateMatch;
      });

      if (blocks.length > 0) {
          const overlappingBlock = blocks.find(b => {
            return desdeMinutos < b.hasta && hastaMinutos > b.desde;
          });
          if (overlappingBlock) {
            return true;
          }
      }

      return false;
    },

    async cambiar_orden_a_profesional() {
      const orden_id = this.id_orden;
      const profesional_id = this.cambiar_profesional.profesional.id;
      const horario_id = this.cambiar_profesional.horario.id;
      const dia = this.cambiar_profesional.dt_dia;
      let desde = this.cambiar_profesional.hora.desde;
      let hasta = this.cambiar_profesional.hora.hasta;
      const desdeMinutos =
        parseInt(desde.split(":")[0]) * 60 + parseInt(desde.split(":")[1]);
      const hastaMinutos =
        parseInt(hasta.split(":")[0]) * 60 + parseInt(hasta.split(":")[1]);

      // Check for blocked schedule
      if (this.isBlocked(profesional_id, dia, desdeMinutos, hastaMinutos)) {
        const ok = window.confirm(
          "Este profesional tiene el horario bloqueado de manera intencionada. ¿Desea agendarle igualmente?"
        );
        if (!ok) return;
      }

      await axios
        .post(window.hostname + "/api/admin/schedule/change_order", {
          orden_id: orden_id,
          profesional_id: profesional_id,
          horario_id: horario_id,
          dia: dia,
          desde: desdeMinutos
        })
        .then(response => {
          alert(response.data.message);
        })
        .then(async () => {
          await this.get_ordenes();
        })
        .then(() => {
          this.cambiar_profesional_cerrar();
        })
        .catch(e => {
          console.log(e.response);
        });
    },

    subir_resultados() {
      let data = new FormData();
      data.append("orden_id", this.id_orden);

      let res = [];
      for (var i = 0; i < this.subiendo_resultados.resultados.length; i++) {
        data.append(i, this.subiendo_resultados.resultados[i].resultado);
        res.push({
          cliente_id: this.subiendo_resultados.resultados[i].cliente_id,
          key: i
        });
      }
      const documento = new Blob([JSON.stringify({ results: res })], {
        type: "application/json"
      });
      data.append("resultados", documento);
      if (this.subiendo_resultados.resultados.length > 0) {
        axios({
          method: "post",
          url: window.hostname + "/api/admin/subir_resultado",
          data: data
        })
          .then(response => {
            this.get_ordenes();
            this.$notify({
              group: "foo",
              title: "¡Éxito!",
              text: "¡Se han subido los resultados exitosamente!",
              type: "success"
            });
            this.limpiar_subiendo_resultados();
          })

          .catch(e => {
            console.log(e.response);
            if (e.response.data.message)
              this.resultado = e.response.data.message;
          });
      }
    },
    goto_resultados() {
      this.$router.push({
        name: "SubirResultado",
        params: { ordenId: this.id_orden }
      });
    },
    goto_modificar() {
      this.$router.push({ path: "/ModificarOrden/" + this.id_orden });
    },
    goto_receta() {
      this.$router.push({ path: "/VerReceta/" + this.id_orden });
    },

    goto_modificar_hora() {
      this.$router.push({ path: "/ModificarHorario/" + this.id_orden });
    },
    marcar_pagado(e) {
      axios
        .post(window.hostname + "/api/admin/marcar_pagado", {
          orden_id: this.id_orden
        })
        .then(response => {
          this.get_ordenes();
          this.popup = false;
        })

        .catch(e => {
          if (e.response.data.message) this.resultado = e.response.data.message;
        });
    },
    toggleConfirmSubMenu(event) {
      if (event) event.stopPropagation();
      this.showConfirmSubMenu = !this.showConfirmSubMenu;
    },
    enviar_confirmacion_whatsapp() {
      let o = this.ordenes.find(x => x.id == this.id_orden);
      if (o && o.contactado_whatsapp == 3) {
        if (
          !confirm(
            "Ya se le ha enviado una confirmación por WhatsApp a este paciente. ¿Deseas enviarla de nuevo?"
          )
        ) {
          return;
        }
      }

      axios
        .post(window.hostname + "/api/admin/enviar_whatsapp_confirmacion", {
          orden_id: this.id_orden
        })
        .then(response => {
          this.$notify({
            group: "foo",
            title: "¡Éxito!",
            text: "¡Se ha enviado la confirmación por WhatsApp!",
            type: "success"
          });
          this.get_ordenes();
          this.popup = false;
          this.showConfirmSubMenu = false;
        })
        .catch(e => {
          console.error(e);
          this.$notify({
            group: "foo",
            title: "Error",
            text: e.response?.data?.message || "Error al enviar WhatsApp",
            type: "error"
          });
          this.popup = false;
          this.showConfirmSubMenu = false;
        });
    },
    enviar_confirmacion_email(e) {
      if (this.prestador && this.prestador.id == 16) {
        this.$notify({
          group: "foo",
          title: "Acción no permitida",
          text: "Por petición de su administrador, UC en casa no puede enviar correos.",
          type: "error"
        });
        this.popup = false;
        this.showConfirmSubMenu = false;
        return;
      }
      axios
        .post(window.hostname + "/api/admin/enviar_correo_confirmacion", {
          orden_id: this.id_orden
        })
        .then(response => {
          this.$notify({
            group: "foo",
            title: "¡Éxito!",
            text: "¡Se ha enviado el correo de confirmación!",
            type: "success"
          });
          this.get_ordenes();
          this.popup = false;
          this.showConfirmSubMenu = false;
        })

        .catch(e => {
          if (e.response.data.message) this.resultado = e.response.data.message;
        });
    },
    copiar_link_pago(){
        axios.post(window.hostname+'/api/admin/obtener_link_pago', 
        {orden_id:this.id_orden})
        .then(response => 
        {

          navigator.clipboard.writeText(response.data.link);
          this.popup = false;
          this.$notify({
          group: 'foo',
          title: '¡Éxito!',
          text: '¡Se ha copiado el link de pago!',
          type:'success'
          });
        })

        .catch(e=>{
          console.log(e.response)
          this.popup = false;
        
        })
    },
    copiar_orden() {
      let orden = this.ordenes.find(x => x.id == this.id_orden);
      this.$refs.modalcopiarorden.show(orden);
    },

    toggleColumnsMenu(e) {
      e.stopPropagation();
      this.menuCol = !this.menuCol;

      // Si se abre el menú, añade event listener para cerrarlo al hacer clic fuera
      if (this.menuCol) {
        setTimeout(() => {
          document.addEventListener("click", this.closeColumnsMenu);
        }, 10);
      }
    },
    closeColumnsMenu() {
      this.menuCol = false;
      document.removeEventListener("click", this.closeColumnsMenu);
    },
    setCol(x) {
      if (this[x] == "true") this[x] = "false";
      else this[x] = "true";

      localStorage.setItem(x, this[x]);
    },
    compareDt(a, b) {
      let da = new Date(
        a.fecha.a,
        a.fecha.m,
        a.fecha.d,
        a.fecha.h,
        a.fecha.min,
        a.fecha.seg
      );
      let db = new Date(
        b.fecha.a,
        b.fecha.m,
        b.fecha.d,
        b.fecha.h,
        b.fecha.min,
        b.fecha.seg
      );
      if (da > db) {
        return -1;
      }
      if (da < db) {
        return 1;
      }
      return 0;
    },
    timeConvert(n) {
      var num = n;
      var hours = num / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      return (
        (rhours < 10 ? "0" : "") +
        rhours +
        ":" +
        (rminutes < 10 ? "0" : "") +
        rminutes +
        ""
      );
    },
    mouseEnter(event, order_id, orden_desde, orden_hasta, profesional) {
      if (profesional == null) {
        profesional = "No asignado";
      } else {
        profesional = `${profesional.nombre} ${profesional.apellido}`;
      }

      if (!event.target.classList.contains("no-menu")) {
        this.popup = true;
        this.id_orden = order_id;
        this.orden_desde = orden_desde;
        this.orden_hasta = orden_hasta;
        this.profesional = profesional;
        //this.$el.addEventListener('mousemove', this.mouseMove, false);
        this.mouseX = event.clientX;
        this.mouseY = event.clientY;
        this.showConfirmSubMenu = false;
      }
    },
    mouseLeave(event) {
      if (!(event.clientX >= this.mouseX && event.clientY >= this.mouseY)) {
        this.popup = false;
      }
    },
    open() {
      // Asegúrate que `id_orden` esté seteado previamente o pásalo directo
      this.$refs.modalComentario.open(this.id_orden);
      console.log("comentado");
    },
    close(e) {
      /*Si clickeo (e.target) fuera de este componente (this.$el), se cierra*/
      if (!e.target.classList.contains("dontClose"))
        this.showinFuncionesList = false;

      if (!e.target.classList.contains("cmt") && this.comentando)
        this.comentando = false;

      if (
        !e.target.classList.contains("result") &&
        this.subiendo_resultados.subiendo
      )
        this.limpiar_subiendo_resultados();

      if (!e.target.classList.contains("menuCol")) this.menuCol = false;
    },
    async get_ordenes() {
      this.call_n += 1;
      const currentCall = this.call_n;

      if (this.desde.a !== 0 && this.hasta.a !== 0) {
        this.cargando_ordenes = true;

        try {
          const response = await axios.post(
            `${window.hostname}/api/admin/get_ordenes_dia`,
            {
              dia: this.desde.d,
              mes: this.desde.m,
              año: this.desde.a,
              dia2: this.hasta.d,
              mes2: this.hasta.m,
              año2: this.hasta.a
            }
          );

          this.cargando_ordenes = false;

          if (currentCall === this.call_n) {
            this.ordenes = response.data.ordenes;

            if (this.prestador.id !== 1) {
              this.ordenes = this.ordenes.filter(
                orden =>
                  orden.orden_propia === true || orden.orden_tomada === true
              );
            }

            // Define the compare function outside the loop for better performance
            const compare = (a, b) => {
              const da = new Date(
                a.fecha.a,
                a.fecha.m - 1,
                a.fecha.d,
                Math.floor(a.desde / 60)
              );
              const db = new Date(
                b.fecha.a,
                b.fecha.m - 1,
                b.fecha.d,
                Math.floor(b.desde / 60)
              );

              if (
                a.urgente &&
                a.estado === 1 &&
                !(b.urgente && b.estado === 1)
              ) {
                return -1;
              }
              if (
                !(a.urgente && a.estado === 1) &&
                b.urgente && b.estado === 1
              ) {
                return 1;
              }
              return da - db;
            };

            this.ordenes_calculated = [];
            const hoy = new Date();

            this.ordenes.forEach(orden => {
              const ins = { ...orden };
              const dia = new Date(ins.fecha.a, ins.fecha.m - 1, ins.fecha.d);
              const diferenciaHoras =
                (dia.getTime() + 1000 * 60 * ins.desde - hoy.getTime()) /
                (1000 * 60 * 60);

              ins.urgente = diferenciaHoras < 48; // 2 * 24 hours
              ins.viendoHistorial = false;
              ins.viendoComentarios = false;
              ins.dia = dia;

              try {
                ins.email = ins.clientes[0].email;
              } catch (e) {
                console.error("Error fetching email:", e);
                ins.email = "";
              }

              this.ordenes_calculated.push(ins);
            });

            this.ordenes_calculated.sort(compare);
          }

          this.$notify({
            group: "foo",
            title: "¡Atenciones encontradas!",
            text: "Revise abajo las atenciones",
            type: "succes"
          });
        } catch (error) {
          console.error("Error fetching órdeness:", error);
          this.$notify({
            group: "foo",
            title: "¡No hay atenciones para la fecha ingresada!",
            text: "Intenta cambiar los filtros de fecha",
            type: "error"
          });
          this.cargando_ordenes = false;
          // Optionally, you can rethrow the error if you want the caller to handle it
          // throw error;
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "comunas",
      "regiones",
      "prestaciones",
      "prestador",
      "admin_datos",
      "examenes",
      "aseguradoras"
    ])
  },
  watch: {
    dt_dia(val) {
      var datos = val.split("-");
      this.desde = {
        a: Number(datos[0]),
        m: Number(datos[1]),
        d: Number(datos[2])
      };
      this.get_ordenes();
    },
    dt_dia2(val) {
      var datos = val.split("-");
      this.hasta = {
        a: Number(datos[0]),
        m: Number(datos[1]),
        d: Number(datos[2])
      };
      this.get_ordenes();
    }
  },
  mounted() {
    this.getNotificaciones();

    if (this.prestador.admin.config.dynamicColumns != undefined) {
      this.dynamicColumns = this.prestador.admin.config.dynamicColumns;
    }

    this.$root.$on("Filtros", data => {
      let filtro = this.filtros.find(x => x.nombre == data.nombre);
      /*     console.log(data.valor)
          console.log("Parte:", filtro.excluidos) */
      if (filtro.excluidos.includes(data.valor)) {
        filtro.excluidos.splice(filtro.excluidos.indexOf(data.valor), 1);
      } else {
        filtro.excluidos.push(data.valor);
      }
      /*     console.log("Termina:", filtro.excluidos) */
      this.$forceUpdate();
    });

    const scrollDiv = document.querySelector(".scroll-div");

    let isDragging = false;
    let lastX;

    scrollDiv.addEventListener("mousedown", e => {
      isDragging = true;
      lastX = e.clientX;
      scrollDiv.style.cursor = "grabbing";
    });

    document.addEventListener("mousemove", e => {
      if (!isDragging) return;

      const deltaX = lastX - e.clientX;
      scrollDiv.scrollLeft += deltaX;

      lastX = e.clientX;
    });

    document.addEventListener("mouseup", () => {
      isDragging = false;
      scrollDiv.style.cursor = "grab";
    });

    this.$forceUpdate();
    document.addEventListener("click", this.close);
    var hoy = new Date();
    this.dt_dia = hoy.toISOString().split("T")[0];
    hoy.setDate(hoy.getDate());
    this.dt_dia2 = hoy.toISOString().split("T")[0];

    document.addEventListener("touchstart", () => { this.popup = false });
    document.addEventListener("scroll", () => { this.popup = false }, true);
  },
  beforeUnmount() {
    this.removeDynamicStyles();
    document.removeEventListener("click", this.close);
  }
};
</script>

<style scoped>
.medical-sidebar-container {
  width: 100%;
}

.modal-simple {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-contenido {
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 80%;
  max-width: 500px;
}

.modal-contenido textarea {
  width: 100%;
  height: 100px;
  margin: 10px 0;
}

.modal-botones {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.medical-orders-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", sans-serif;
  color: #1e293b;
}

.column-left {
  position: fixed;
  left: 0;
  top: 0;
  width: 280px;
  height: 100vh;
  z-index: 1000;
}

.column-right {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding-top: 0px;
  padding-left: 275px;
  width: 100%;
  min-height: 100vh;
}

.main-container {
  padding: 20px;
}

.professionals-container {
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    sans-serif;
}

.page-header {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.page-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem;
  letter-spacing: -0.025em;
}

.page-subtitle {
  font-size: 1.125rem;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.header-actions {
  background-color: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 1rem;
  margin-bottom: 1rem;
  width: 100%;
}

.view-toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.view-toggle-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Controls Section */
.controls-section {
  margin-bottom: 2rem;
}

.info-banner {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.5rem;
  background: #f0f9ff;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  border: 1px solid #bae6fd;
}

.info-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #0ea5e9, #0284c7);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.info-content p {
  color: #0c4a6e;
  font-size: 0.875rem;
  margin: 0;
  line-height: 1.5;
}

.controls-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.control-group {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.control-btn {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 120px;
  justify-content: center;
}

.control-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.dropdown-container {
  position: relative;
  display: inline-block;
}

.dropdown-menu {
  position: absolute;
  left: 0;
  top: 100%;
  z-index: 1000;
  min-width: 200px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-top: 5px;
}

.dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.check-icon {
  margin-left: 10px;
}

.check-icon.active {
  color: green;
}

.check-icon.inactive {
  color: #ccc;
}

.date-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.date-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.date-field label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
}

.date-input {
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  background: white;
}

.date-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Context Menu */
.context-menu {
  position: fixed;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  overflow: hidden;
  min-width: 220px;
}

.context-menu-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.875rem;
  font-weight: 500;
}

.context-menu-item:last-child {
  border-bottom: none;
}

.context-menu-item:hover {
  background: #f8fafc;
}

.context-menu-item.danger {
  color: #ef4444;
}

.context-menu-item.danger:hover {
  background: #fef2f2;
}

.context-menu-item.sub-item {
  padding-left: 2.5rem;
  background: #fcfdfe;
  font-size: 0.825rem;
}

.context-menu-item.sub-item:hover {
  background: #f1f5f9;
}

/* Orders Container */
.orders-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.orders-content-wrapper {
  min-height: 400px;
}

/* Desktop Table View */
.desktop-only {
  display: block;
}

.mobile-view {
  display: none;
}

.table-container {
  overflow-x: auto;
  max-height: calc(100vh - 400px);
}

.table-container.dragging {
  cursor: grabbing;
  user-select: none;
}

.orders-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  min-width: 1400px;
}

.orders-table th {
  background: #f8fafc;
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: #475569;
  font-size: 0.875rem;
  border-bottom: 2px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 10;
  white-space: nowrap;
}

.orders-table th.sortable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.orders-table th.sortable:hover {
  background: #f1f5f9;
  color: #1e293b;
}

.th-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.sort-icon {
  color: #94a3b8;
}

.orders-table td {
  padding: 1rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: top;
  font-size: 0.875rem;
}

.table-row {
  transition: all 0.2s ease;
  cursor: pointer;
}

.table-row:hover {
  background-color: #f8fafc;
}

.table-row.urgent {
  background-color: #fef3c7 !important;
  border-left: 4px solid #f59e0b;
}

.table-row.inactive {
  opacity: 0.5;
}

/* Table Cell Styles */
.cell-id {
  text-align: center;
  font-weight: 600;
  color: #64748b;
  width: 80px;
}

.cell-provider .provider-own {
  color: #3b82f6;
  font-weight: 600;
}

.cell-provider .provider-external {
  color: #ef4444;
  font-weight: 600;
}

.cell-professional .professional-assigned {
  color: #1e293b;
  font-weight: 500;
}

.cell-professional .professional-unassigned {
  color: #ef4444;
  font-weight: 600;
}

.cell-date {
  min-width: 180px;
}

.date-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.copy-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  opacity: 0.7;
}

.copy-btn:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.05);
}

.cell-client {
  min-width: 200px;
}

.client-item {
  margin-bottom: 0.5rem;
}

.client-item:last-child {
  margin-bottom: 0;
}

.client-name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: #1e293b;
}

.insurance-badge {
  font-size: 0.75rem;
  color: #64748b;
  background: #f1f5f9;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  margin-top: 0.25rem;
  display: inline-block;
}

.cell-rut,
.cell-email,
.cell-phone {
  min-width: 150px;
}

.rut-item,
.email-item,
.phone-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
}

.prescription-link {
  display: inline-block;
  cursor: pointer;
  margin-right: 0.5rem;
  font-weight: 600;
  transition: all 0.2s ease;
}

.prescription-link:hover {
  text-decoration: underline;
}

.cell-amount,
.cell-discount,
.cell-surcharge,
.cell-paid-amount {
  text-align: right;
  font-weight: 600;
}

.amount-value {
  color: #059669;
}

.discount-value {
  color: #dc2626;
}

.surcharge-value {
  color: #ea580c;
}

.paid-amount-value {
  color: #7c3aed;
}

.cell-schedule {
  min-width: 120px;
}

.schedule-text {
  font-family: "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas,
    "Courier New", monospace;
  background: #f1f5f9;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 0.8rem;
}

.cell-status {
  min-width: 140px;
}

.status-select {
  width: 100%;
  padding: 0.5rem;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  background: white;
  transition: all 0.2s ease;
}

.status-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.cell-contact {
  min-width: 180px;
}

.contact-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  color: white;
  margin-bottom: 0.25rem;
}

.contact-badge.whatsapp {
  background: #25d366 !important;
}

.contact-badge.no-contact {
  background: #6b7280 !important;
}

.cell-paid,
.cell-results,
.cell-prescription {
  text-align: center;
  width: 80px;
}

.status-icon {
  display: flex;
  justify-content: center;
}

.icon-success {
  color: #10b981;
}

.icon-error {
  color: #ef4444;
}

.cell-commune,
.cell-address {
  min-width: 150px;
}

.address-content {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.cell-comments {
  min-width: 250px;
}

.comments-content {
  max-height: 120px;
  overflow-y: auto;
}

.comment-item {
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f5f9;
}

.comment-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.comment-header {
  font-size: 0.75rem;
  color: #64748b;
  margin-bottom: 0.25rem;
}

.comment-text {
  font-size: 0.875rem;
  line-height: 1.4;
}

.delete-comment-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #ef4444;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.delete-comment-btn:hover {
  background: #fef2f2;
}

.toggle-comments-btn,
.toggle-history-btn {
  background: none;
  border: 2px solid;
  padding: 0.375rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  color: white;
  margin-top: 0.5rem;
  transition: all 0.2s ease;
}

.toggle-comments-btn:hover,
.toggle-history-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.cell-additional-info {
  min-width: 200px;
}

.additional-info-item {
  margin-bottom: 0.5rem;
}

.info-badge {
  background: #dbeafe;
  color: #1e40af;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 0.5rem;
}

.cell-history {
  min-width: 250px;
}

.history-content {
  max-height: 120px;
  overflow-y: auto;
}

.history-item {
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f5f9;
}

.history-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.history-date {
  font-size: 0.75rem;
  color: #64748b;
  margin-bottom: 0.25rem;
}

.history-text {
  font-size: 0.875rem;
  line-height: 1.4;
}

.history-toggle {
  text-align: center;
  padding: 0.5rem 0;
}

.cell-exams {
  min-width: 200px;
}

.exam-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
  padding: 0.25rem 0;
}

.exam-quantity {
  background: #f1f5f9;
  color: #64748b;
  padding: 0.125rem 0.375rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  min-width: 24px;
  text-align: center;
}

.exam-name {
  font-weight: 500;
  color: #1e293b;
}

.exam-code {
  color: #64748b;
  font-size: 0.875rem;
}

.cell-attributes {
  min-width: 150px;
}

.attributes-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.attribute-item {
  font-size: 0.875rem;
  line-height: 1.4;
}

.no-attributes {
  color: #94a3b8;
  font-style: italic;
}

.cell-dynamic {
  min-width: 120px;
}

.dynamic-input,
.dynamic-select {
  width: 100%;
  padding: 0.5rem;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  background: white;
  transition: all 0.2s ease;
}

.dynamic-input:focus,
.dynamic-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Mobile Card View */
.orders-cards {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.order-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s ease;
  cursor: pointer;
}

.order-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.order-card.urgent {
  border-color: #f59e0b;
  background: #fefbf3;
}

.order-card.inactive {
  opacity: 0.6;
}

.card-header {
  background: #f8fafc;
  padding: 1rem;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-id {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.id-badge {
  background: #e2e8f0;
  color: #64748b;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
}

.urgent-badge {
  background: #f59e0b;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
}

.card-date {
  font-size: 0.875rem;
  color: #64748b;
  font-weight: 500;
}

.card-body {
  padding: 1.5rem;
}

.patient-info {
  margin-bottom: 1.5rem;
}

.patient-item {
  margin-bottom: 1rem;
}

.patient-item:last-child {
  margin-bottom: 0;
}

.patient-name {
  font-size: 1.125rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem;
}

.patient-details {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.patient-rut,
.patient-phone {
  font-size: 0.875rem;
  color: #64748b;
  background: #f1f5f9;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
}

.insurance-info {
  font-size: 0.875rem;
  color: #64748b;
  font-style: italic;
}

.appointment-info {
  margin-bottom: 1.5rem;
}

.info-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.info-item.full-width {
  grid-column: 1 / -1;
}

.info-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.info-value {
  font-size: 0.875rem;
  font-weight: 500;
  color: #1e293b;
}

.info-value-missing {
  font-size: 0.875rem;
  font-weight: 600;
  color: #ef4444;
}

.info-value.amount {
  color: #059669;
  font-weight: 700;
}

.mobile-status-select {
  width: 100%;
  padding: 0.5rem;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  background: white;
  margin-top: 0.25rem;
}

.card-badges {
  margin-bottom: 1rem;
}

.status-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid;
}

.status-badge.paid {
  background: #dcfce7;
  color: #166534;
  border-color: #bbf7d0;
}

.status-badge.unpaid {
  background: #fef2f2;
  color: #991b1b;
  border-color: #fecaca;
}

.status-badge.results {
  background: #dbeafe;
  color: #1e40af;
  border-color: #bfdbfe;
}

.status-badge.no-results {
  background: #fef3c7;
  color: #92400e;
  border-color: #fde68a;
}

.status-badge.prescription-ok {
  background: #d1fae5;
  color: #065f46;
  border-color: #a7f3d0;
}

.status-badge.prescription-needed {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fecaca;
}

.exams-section {
  border-top: 1px solid #f1f5f9;
  padding-top: 1rem;
}

.section-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
  margin: 0 0 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.exams-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.exam-item-mobile {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: #f8fafc;
  border-radius: 8px;
}

/* Loading States */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.loading-text {
  color: #64748b;
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
}

.main-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 140px);
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  backdrop-filter: blur(4px);
}

.modal-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.comment-modal {
  width: 600px;
  height: 400px;
}

.upload-modal {
  width: 700px;
  max-height: 80vh;
}

.professional-modal {
  width: 800px;
  max-height: 85vh;
}

.modal-header {
  background: #f8fafc;
  padding: 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.modal-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #64748b;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.modal-close-btn:hover {
  color: #1e293b;
  background: #f1f5f9;
}

.modal-body {
  padding: 1.5rem;
  flex: 1;
  overflow-y: auto;
}

.modal-footer {
  background: #f8fafc;
  padding: 1.5rem;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

/* Comment Modal Specific */
.comment-textarea {
  width: 100%;
  height: 200px;
  padding: 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 0.875rem;
  font-family: inherit;
  resize: none;
  transition: all 0.2s ease;
}

.comment-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.character-count {
  text-align: right;
  font-size: 0.75rem;
  color: #64748b;
  margin-top: 0.5rem;
}

/* Upload Modal Specific */
.upload-client-section {
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #f1f5f9;
}

.upload-client-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.client-name {
  font-size: 1.125rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 1rem;
}

.file-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.file-upload-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.file-upload-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.uploaded-files {
  margin-top: 1rem;
}

.uploaded-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 0.5rem;
}

.file-name {
  font-size: 0.875rem;
  color: #1e293b;
}

.remove-file-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #ef4444;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.remove-file-btn:hover {
  background: #fef2f2;
}

/* Professional Modal Specific */
.professional-change-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.form-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
}

.form-select,
.form-input {
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.875rem;
  background: white;
  transition: all 0.2s ease;
}

.form-select:focus,
.form-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.no-results-message {
  padding: 1rem;
  background: #fef3c7;
  border: 1px solid #fde68a;
  border-radius: 8px;
  color: #92400e;
  font-size: 0.875rem;
  text-align: center;
}

.force-change-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}

.comparison-table {
  margin-top: 1rem;
}

.comparison-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 1rem;
}

.comparison-table-content {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.comparison-table-content th,
.comparison-table-content td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #f1f5f9;
}

.comparison-table-content th {
  background: #f8fafc;
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
}

.comparison-table-content td {
  font-size: 0.875rem;
  color: #1e293b;
}

.comparison-table-content tbody tr:last-child td {
  border-bottom: none;
}

/* Button Styles */
.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 600;
  background: #f8fafc;
  color: #374151;
  border: 2px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-secondary:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  transform: translateY(-1px);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .column-right {
    margin-left: 0;
  }

  .orders-content {
    padding: 1rem;
  }

  .header-content {
    flex-direction: column;
    gap: 1.5rem;
  }

  .controls-container {
    flex-direction: column;
    gap: 1.5rem;
  }

  .control-group {
    justify-content: center;
  }

  .date-controls {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }

  .mobile-view {
    display: block;
  }

  .orders-content {
    padding: 0.5rem;
  }

  .page-header {
    padding: 1.5rem;
  }

  .title-section {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .page-icon {
    width: 48px;
    height: 48px;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .page-subtitle {
    font-size: 1rem;
  }

  .controls-container {
    padding: 1rem;
  }

  .control-group {
    flex-direction: column;
    width: 100%;
  }

  .control-btn {
    width: 100%;
  }

  .dropdown-menu {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90vw;
    max-width: 300px;
  }

  .date-controls {
    flex-direction: column;
    width: 100%;
  }

  .date-field {
    width: 100%;
  }

  .date-input {
    width: 100%;
  }

  .info-row {
    grid-template-columns: 1fr;
  }

  .modal-container {
    width: 95vw;
    max-height: 95vh;
  }

  .modal-header,
  .modal-body,
  .modal-footer {
    padding: 1rem;
  }

  .comparison-table-content {
    font-size: 0.75rem;
  }

  .comparison-table-content th,
  .comparison-table-content td {
    padding: 0.5rem;
  }
}

@media (max-width: 480px) {
  .orders-content {
    padding: 0.25rem;
  }

  .page-header {
    padding: 1rem;
  }

  .info-banner {
    padding: 1rem;
    flex-direction: column;
    gap: 0.75rem;
  }

  .orders-cards {
    padding: 0.5rem;
  }

  .card-header {
    flex-direction: column;
    gap: 0.75rem;
    align-items: flex-start;
  }

  .patient-details {
    flex-direction: column;
    gap: 0.5rem;
  }

  .status-badges {
    flex-direction: column;
  }

  .modal-header {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }

  .modal-footer {
    flex-direction: column;
  }
}

/* Scrollbar Styling */
.table-container::-webkit-scrollbar,
.comments-content::-webkit-scrollbar,
.history-content::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-container::-webkit-scrollbar-track,
.comments-content::-webkit-scrollbar-track,
.history-content::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb,
.comments-content::-webkit-scrollbar-thumb,
.history-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover,
.comments-content::-webkit-scrollbar-thumb:hover,
.history-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Focus States */
.view-toggle-btn:focus,
.control-btn:focus,
.date-input:focus,
.status-select:focus,
.mobile-status-select:focus,
.dynamic-input:focus,
.dynamic-select:focus,
.comment-textarea:focus,
.form-select:focus,
.form-input:focus,
.btn-primary:focus,
.btn-secondary:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* Print Styles */
@media print {

  .controls-section,
  .context-menu,
  .modal-overlay {
    display: none !important;
  }

  .orders-table {
    font-size: 0.75rem;
  }

  .orders-table th,
  .orders-table td {
    padding: 0.5rem;
  }
}

@media (max-width: 1200px) {
  .column-right {
    padding-left: 0px;
  }
}
</style>
